/*
 * hc-cart.js — carrinho novo (gaveta e página /cart)
 * Layout em snippets/hc-cart.liquid. Opções em Configurações do tema › Carrinho.
 *
 * O tema continua dono da atualização: depois de cada mudança chamamos
 * T4SThemeSP.Cart.renderContents(sections), que troca [data-cart-items] e
 * [data-cart-prices] e dispara "cart:updated". Aqui só ligamos o comportamento.
 */
(function () {
  'use strict';
  if (window.HCCart) return;

  /* ---------------------------------------------------------------- utils */

  var LS = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  };
  var SS = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }
  function btnCls() {
    var r = document.querySelector('[data-hc-btn]');
    var v = (r && r.getAttribute('data-hc-btn')) || 'dark';
    return 'hb-btn t4s-btn-color-' + v.replace(/[^a-z0-9]/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = String(format || 'R$ {{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    function fmt(n, dec, thou, decSep) {
      var neg = n < 0;
      n = Math.abs(n) / 100;
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return (neg ? '-' : '') + (dec ? parts[0] + decSep + parts[1] : parts[0]);
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (key) {
      case 'amount': val = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': val = fmt(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': val = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': val = fmt(cents, 2, ' ', ','); break;
      default: val = fmt(cents, 2, '.', ',');
    }
    return m ? format.replace(m[0], val) : val;
  }

  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function formatCep(s) { var d = digits(s).slice(0, 8); return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; }

  // Estado (UF) pelo CEP — faixas oficiais dos Correios
  var CEP_RANGES = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  function cepToUF(cep) {
    var n = parseInt(digits(cep).slice(0, 5), 10);
    if (isNaN(n)) return '';
    for (var i = 0; i < CEP_RANGES.length; i++) {
      if (n >= CEP_RANGES[i][0] && n <= CEP_RANGES[i][1]) return CEP_RANGES[i][2];
    }
    return '';
  }

  function getCep() {
    var c = digits(LS.get('user_cep') || LS.get('shipping_cep') || '');
    return c.length === 8 ? c : '';
  }
  function saveCep(cep) {
    var f = formatCep(cep);
    LS.set('user_cep', f);
    LS.set('shipping_cep', f);
  }

  /* --------------------------------------------------------- prazo/data */

  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day, 12);
  }
  var holidayCache = {};
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var list = ['01-01', '04-21', '05-01', '09-07', '10-12', '11-02', '11-15', '11-20', '12-25'].map(function (md) { return y + '-' + md; });
    var e = easter(y);
    [-48, -47, -2, 60].forEach(function (off) { // carnaval (seg/ter), sexta santa, corpus christi
      var d = new Date(e); d.setDate(d.getDate() + off); list.push(iso(d));
    });
    holidayCache[y] = list;
    return list;
  }
  function isBizDay(d) {
    var wd = d.getDay();
    return wd !== 0 && wd !== 6 && holidays(d.getFullYear()).indexOf(iso(d)) < 0;
  }
  function today() { var d = new Date(); d.setHours(12, 0, 0, 0); return d; }
  function addDays(n, business) {
    var d = today();
    var left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (!business || isBizDay(d)) left--;
    }
    return d;
  }
  function parseDate(s) {
    var m = String(s || '').match(/(\d{4})-(\d{2})-(\d{2})/);
    return m ? new Date(+m[1], +m[2] - 1, +m[3], 12) : null;
  }

  function rateTiming(rate) {
    var r = rate || {};
    if (Array.isArray(r.delivery_range) && r.delivery_range.length) {
      var d = parseDate(r.delivery_range[r.delivery_range.length - 1]);
      if (d) return { date: d };
    }
    if (r.delivery_date) {
      var d2 = parseDate(r.delivery_date);
      if (d2) return { date: d2 };
    }
    if (Array.isArray(r.delivery_days) && r.delivery_days.length && Number(r.delivery_days[0]) >= 0) {
      var min = Number(r.delivery_days[0]), max = Number(r.delivery_days[1] || r.delivery_days[0]);
      if (max > 0) return { min: min, max: max, business: true };
    }
    var text = (r.name || '') + ' ' + (r.description || '');
    var m = text.match(/(\d{1,2})\s*(?:a|à|-|–|ou|até)\s*(\d{1,2})\s*dias?\s*(úteis|uteis|corridos)?/i);
    if (m) return { min: +m[1], max: +m[2], business: !/corridos/i.test(m[3] || '') };
    m = text.match(/(\d{1,2})\s*dias?\s*(úteis|uteis|corridos)?/i);
    if (m && +m[1] > 0) return { min: +m[1], max: +m[1], business: !/corridos/i.test(m[2] || '') };
    return null;
  }

  var WEEKDAYS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
  function mondayKey(d) { var x = new Date(d); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return iso(x); }

  function deliveryText(rate, cfg, isFree) {
    var t = rateTiming(rate);
    if (!t) return '';
    if (cfg.format === 'days') {
      if (t.max) {
        var unit = t.business ? 'dias úteis' : 'dias';
        if (t.max === 1) return 'até 1 dia' + (t.business ? ' útil' : '');
        return t.min && t.min !== t.max ? t.min + ' a ' + t.max + ' ' + unit : 'até ' + t.max + ' ' + unit;
      }
      return 'até ' + ('0' + t.date.getDate()).slice(-2) + '/' + ('0' + (t.date.getMonth() + 1)).slice(-2);
    }
    var d = t.date || addDays(t.max, t.business);
    var now = today();
    var diff = Math.round((d - now) / 86400000);
    var base = (cfg.prefix || '').trim() || 'Chega até';
    var pre = base;
    if (isFree) pre = / até$/i.test(base) ? base.replace(/ até$/i, ' grátis até') : base + ' grátis';
    if (diff <= 0) return pre.replace(/ até$/i, '') + ' hoje';
    if (diff === 1) return pre.replace(/ até$/i, '') + ' amanhã';
    if (diff <= 7) return pre + ' ' + WEEKDAYS[d.getDay()];
    return pre + ' ' + WEEKDAYS[d.getDay()] + ', ' + ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
  }

  /* --------------------------------------------------------------- estado */

  var S = {
    busy: false,
    couponOpen: null,
    detailsOpen: false,
    similarOpen: {},
    rates: {},          // cache: assinatura -> {at, rates|error}
    shipSeq: 0,
    lastOwnKey: null,
    noteTimer: null
  };

  function cfgOf(root) {
    var ds = root.dataset;
    return {
      mode: ds.hcMode,
      format: ds.deliveryFormat || 'date',
      prefix: ds.deliveryPrefix || 'Chega até',
      country: ds.country || 'BR',
      money: ds.moneyFormat,
      cartUrl: ds.cartUrl || '/cart',
      root: ds.root || '/',
      recsUrl: ds.recsUrl || '/recommendations/products',
      similar: ds.similar || 'off',
      similarCount: parseInt(ds.similarCount, 10) || 3,
      couponCollapsed: ds.couponCollapsed !== 'false'
    };
  }
  function m(root, cents) { return formatMoney(cents, cfgOf(root).money); }

  function sectionsParam() {
    var isCart = !!(window.cartT4SectionID && document.querySelector('.hc-cart--page'));
    return isCart ? 'cart_data,' + window.cartT4SectionID : 'cart_data,mini_cart';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
    });
  }

  var PRICE;
  function priceConfig() {
    if (PRICE) return PRICE;
    var el = document.getElementById('hc-cart-price');
    try { PRICE = el ? JSON.parse(el.textContent) : {}; } catch (e) { PRICE = {}; }
    return PRICE;
  }

  function cartRoute(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + '/cart/' + path;
  }

  // Entrega as seções ao tema (mesmo caminho do "adicionar ao carrinho" do tema)
  function applySections(sections) {
    if (!sections) { return refreshFromServer(); }
    try {
      if (window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.renderContents === 'function') {
        T4SThemeSP.Cart.renderContents(sections);
        return;
      }
    } catch (e) { console.warn('[hc-cart] renderContents falhou, usando atualização própria', e); }
    manualRender(sections);
  }
  function refreshFromServer() {
    return fetch(window.location.pathname + '?sections=' + sectionsParam(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(applySections)
      .catch(function () {});
  }
  function manualRender(sections) {
    var html = sections.mini_cart || sections[window.cartT4SectionID];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['[data-cart-items]', '[data-cart-prices]'].forEach(function (sel) {
      var src = doc.querySelector(sel);
      $$(sel).forEach(function (dst) { if (src) dst.innerHTML = src.innerHTML; });
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    schedule();
  }

  /* --------------------------------------------------- quantidade/remover */

  function setBusy(root, on) {
    S.busy = on;
    $$('[data-hc-cart]').forEach(function (r) { r.classList.toggle('is-busy', on); });
  }

  function changeLine(item, qty) {
    if (S.busy || !item) return;
    var root = item.closest('[data-hc-cart]');
    var key = item.getAttribute('data-key');
    var msg = $('[data-hc-item-msg]', item);
    if (msg) { msg.textContent = ''; show(msg, false); }
    setBusy(root, true);
    item.classList.add('is-loading');
    S.lastOwnKey = key;
    postJSON(cartRoute('change.js'), { id: key, quantity: qty, sections: sectionsParam(), sections_url: window.location.pathname })
      .then(function (res) {
        if (!res.ok) {
          item.classList.remove('is-loading');
          if (msg) {
            msg.textContent = (res.json && (res.json.description || res.json.message)) || 'Não foi possível alterar a quantidade. Tente de novo.';
            show(msg, true);
          }
          return;
        }
        applySections(res.json.sections);
      })
      .catch(function () {
        item.classList.remove('is-loading');
        if (msg) { msg.textContent = 'Sem conexão. Tente de novo.'; show(msg, true); }
      })
      .then(function () { setBusy(root, false); });
  }

  function addVariant(root, variantId, btn, then) {
    if (S.busy) return Promise.resolve();
    setBusy(root, true);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adicionando…'; }
    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (!then) { payload.sections = sectionsParam(); payload.sections_url = window.location.pathname; }
    return postJSON(cartRoute('add.js'), payload)
      .then(function (res) {
        if (!res.ok) {
          if (btn) { btn.disabled = false; btn.textContent = 'Indisponível'; setTimeout(function () { btn.textContent = label; }, 2200); }
          setBusy(root, false);
          return;
        }
        setBusy(root, false);
        if (then) return then();
        applySections(res.json.sections);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        setBusy(root, false);
      });
  }

  /* --------------------------------------------------------------- cupom */

  function currentCodes(root) {
    var st = $('[data-hc-state]', root);
    var raw = st ? st.getAttribute('data-codes') : '';
    return raw ? raw.split(',').map(function (c) { return c.trim(); }).filter(Boolean) : [];
  }

  function couponError(box, on, text) {
    var err = $('[data-hc-coupon-err]', box);
    if (!err) return;
    if (text) err.textContent = text;
    show(err, on);
  }

  function applyCoupon(box) {
    var root = box.closest('[data-hc-cart]');
    var input = $('[data-hc-coupon-input]', box);
    var btn = $('[data-hc-coupon-apply]', box);
    var code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    if (S.busy) return;
    var before = currentCodes(root);
    var list = before.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); }).concat([code]);
    couponError(box, false);
    setBusy(root, true);
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    function done() { setBusy(root, false); if (btn) { btn.disabled = false; btn.textContent = 'Aplicar'; } }

    postJSON(cartRoute('update.js'), { discount: list.join(','), sections: sectionsParam(), sections_url: window.location.pathname })
      .then(function (res) {
        var j = res.json || {};
        if (res.ok && Array.isArray(j.discount_codes)) {
          var hit = j.discount_codes.filter(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); })[0];
          if (hit && hit.applicable) {
            track('hc_coupon_applied', { code: code });
            S.couponOpen = false;
            done();
            applySections(j.sections);
            return;
          }
          // não vale: volta para os códigos anteriores e mantém o que a cliente digitou
          return postJSON(cartRoute('update.js'), { discount: before.join(',') }).then(function () {
            done();
            couponError(box, true, 'Cupom inválido ou não válido para este carrinho. Confira o código e as regras do cupom.');
            track('hc_coupon_invalid', { code: code });
          });
        }
        // loja sem suporte ao parâmetro "discount": usa a rota /discount/CODIGO
        return fetch(cartRoute('').replace(/cart\/$/, '') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartRoute('').replace(/\/$/, '') + '.js'), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var ok = (cart.cart_level_discount_applications || []).concat([]).some(function (a) { return String(a.title).toUpperCase() === code.toUpperCase(); }) ||
              (cart.items || []).some(function (it) { return (it.line_level_discount_allocations || []).some(function (a) { return a.discount_application && String(a.discount_application.title).toUpperCase() === code.toUpperCase(); }); });
            done();
            if (ok) { S.couponOpen = false; refreshFromServer(); }
            else couponError(box, true, 'Cupom inválido ou não válido para este carrinho. Confira o código e as regras do cupom.');
          });
      })
      .catch(function () { done(); couponError(box, true, 'Não foi possível aplicar agora. Tente de novo.'); });
  }

  function removeCoupon(btn) {
    var root = btn.closest('[data-hc-cart]');
    if (S.busy) return;
    var code = btn.getAttribute('data-code') || '';
    var list = currentCodes(root).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
    setBusy(root, true);
    btn.textContent = '…';
    postJSON(cartRoute('update.js'), { discount: list.join(','), sections: sectionsParam(), sections_url: window.location.pathname })
      .then(function (res) { setBusy(root, false); applySections(res.json && res.json.sections); })
      .catch(function () { setBusy(root, false); btn.textContent = 'Remover'; });
  }

  /* --------------------------------------------------------------- frete */

  function rateKey(r) { return (r.code || '') + '|' + (r.name || ''); }
  function rateName(r) { return r.name === 'Local Delivery' ? 'Motoboy' : (r.name || 'Entrega'); }
  function rateCents(r) { return Math.round(parseFloat(r.price || 0) * 100); }

  function fetchRates(cep, country) {
    var uf = cepToUF(cep);
    var q = 'shipping_address[zip]=' + encodeURIComponent(formatCep(cep)) +
      '&shipping_address[country]=' + encodeURIComponent(country === 'BR' ? 'BR' : country) +
      (uf ? '&shipping_address[province]=' + uf : '');
    var url = cartRoute('shipping_rates.json') + '?' + q;
    function attempt(n) {
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
        if (r.status === 429 && n < 2) return new Promise(function (ok) { setTimeout(ok, 1200 * (n + 1)); }).then(function () { return attempt(n + 1); });
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (r.ok && Array.isArray(j.shipping_rates)) {
            return { rates: j.shipping_rates.slice().sort(function (a, b) { return rateCents(a) - rateCents(b); }) };
          }
          return { error: true };
        });
      });
    }
    return attempt(0).catch(function () { return { error: true, offline: true }; });
  }

  function userChoice() {
    var at = parseInt(LS.get('hc_ship_choice_at') || '0', 10);
    if (LS.get('user_chose_shipping') !== 'true') return null;
    if (at && Date.now() - at > 30 * 60 * 1000) { LS.del('user_chose_shipping'); return null; }
    return { code: LS.get('selected_shipping_code'), name: LS.get('selected_shipping_name') };
  }

  function persistRate(r, byUser) {
    LS.set('selected_shipping_price', (rateCents(r) / 100).toFixed(2));
    LS.set('selected_shipping_name', r.name || '');
    LS.set('selected_shipping_code', r.code || '');
    LS.set('selected_shipping_carrier', r.carrier_identifier || '');
    LS.set('selected_shipping_service', r.carrier_service_id != null ? String(r.carrier_service_id) : '');
    LS.set('selected_shipping_handle', r.carrier_identifier || r.code || '');
    if (byUser) { LS.set('user_chose_shipping', 'true'); LS.set('hc_ship_choice_at', String(Date.now())); }
  }
  function hasFree(rates) { return (rates || []).some(function (r) { return rateCents(r) === 0; }); }

  function chooseRate(rates) {
    if (!rates || !rates.length) return { sel: null, notice: '' };
    var choice = userChoice();
    var sel = null, notice = '';
    var free = rates.filter(function (r) { return rateCents(r) === 0; })[0] || null;
    if (choice) {
      sel = rates.filter(function (r) { return r.code === choice.code && r.name === choice.name; })[0] ||
        rates.filter(function (r) { return r.code === choice.code; })[0] || null;
      // escolheu um frete pago quando ainda não havia grátis: agora que ganhou, vale o grátis
      if (sel && free && rateCents(sel) > 0 && LS.get('hc_choice_had_free') !== '1') {
        sel = free;
        LS.del('user_chose_shipping');
      }
      if (!sel && parseFloat(LS.get('selected_shipping_price') || '1') === 0) {
        notice = 'O carrinho ficou abaixo do frete grátis. Selecionamos a opção mais barata.';
        LS.del('user_chose_shipping');
      }
    }
    if (!sel) sel = rates[0];
    persistRate(sel, false);
    return { sel: sel, notice: notice };
  }

  function cartSig(root) {
    var st = $('[data-hc-state]', root);
    return st ? st.getAttribute('data-sig') : '';
  }

  function updateShipping(root, opts) {
    opts = opts || {};
    var foot = $('[data-hc-foot]', root);
    if (!foot) return;
    var cep = getCep();
    var cfg = cfgOf(root);
    root._shipCep = cep;
    var known = cep ? S.rates[cartSig(root) + '|' + cep] : null;
    root._freeAvail = known && !known.error && known.rates ? hasFree(known.rates) : null;
    renderGoals(root);
    if (!cep) { paintShip(root, { state: 'nocep' }); return; }
    var sig = cartSig(root) + '|' + cep;
    var hit = S.rates[sig];
    if (hit && Date.now() - hit.at < 10 * 60 * 1000 && !opts.force) {
      paintShip(root, hit.error ? { state: 'error', cep: cep } : Object.assign({ state: 'ok', cep: cep, rates: hit.rates }, chooseRate(hit.rates)));
      return;
    }
    paintShip(root, { state: 'loading', cep: cep });
    var seq = ++S.shipSeq;
    fetchRates(cep, cfg.country).then(function (res) {
      S.rates[sig] = { at: Date.now(), rates: res.rates, error: !!res.error };
      if (seq !== S.shipSeq) return;
      $$('[data-hc-cart]').forEach(function (r) {
        if (cartSig(r) + '|' + getCep() !== sig) return;
        var fa = res.error ? null : hasFree(res.rates);
        if (fa !== r._freeAvail) { r._freeAvail = fa; renderGoals(r); }
        if (res.error) paintShip(r, { state: 'error', cep: cep });
        else paintShip(r, Object.assign({ state: 'ok', cep: cep, rates: res.rates }, chooseRate(res.rates)));
      });
      var sheet = $('[data-hc-sheet]', root);
      if (sheet && !sheet.hasAttribute('hidden')) renderRateList(root);
    });
  }

  // valor no PIX: se a Shopify já aplicou o desconto de PIX, usa o total dela; senão, aplica o % de Configuração de Preços
  function pixValue(foot, total, ship, pct) {
    var pd = parseInt(foot.getAttribute('data-pix-disc'), 10) || 0;
    if (pd > 0) return (parseInt(foot.getAttribute('data-pix-total'), 10) || 0) + ship;
    return Math.round(total * (1 - pct / 100) + ship);
  }
  function pixOn(foot, pct) {
    return foot.getAttribute('data-show-pix') === 'true' && (pct > 0 || (parseInt(foot.getAttribute('data-pix-disc'), 10) || 0) > 0);
  }

  function paintShip(root, info) {
    var foot = $('[data-hc-foot]', root);
    if (!foot) return;
    var cfg = cfgOf(root);
    var total = parseInt(foot.getAttribute('data-total'), 10) || 0;
    var reached = !!(root._fs && root._fs.reached);
    var hasBar = !!(root._fs && root._fs.simple);
    var val = $('[data-hc-ship-val]', foot);
    var sub = $('[data-hc-ship-sub]', foot);
    var row = $('[data-hc-ship-row]', foot);
    var notice = $('[data-hc-ship-notice]', foot);
    var detail = $('[data-hc-detail-ship]', foot);
    var fsSub = $('[data-hc-fs-sub]', foot);
    var cepLabel = $('[data-hc-cep-label]', foot);
    var cepBtn = $('[data-hc-cep-btn]', foot);
    var sel = info.sel || null;
    var shipCents = sel ? rateCents(sel) : 0;

    var ask = $('[data-hc-ship-ask]', foot);
    var res = $('[data-hc-ship-res]', foot);
    var nameEl = $('[data-hc-ship-name]', foot);
    var loading = info.state === 'loading';
    if (row) row.classList.toggle('is-ask', !sel && !loading);
    if (ask) show(ask, !sel && !loading);
    if (res) show(res, !!sel || loading);
    if (nameEl) nameEl.textContent = loading ? 'Calculando o frete…' : (sel ? rateName(sel) : '');
    if (val) {
      val.classList.remove('is-cta', 'is-free', 'is-muted');
      if (loading) val.textContent = '';
      else if (sel) { val.textContent = shipCents === 0 ? 'Grátis' : m(root, shipCents); if (shipCents === 0) val.classList.add('is-free'); }
      else val.textContent = '';
    }
    var dt = sel ? deliveryText(sel, cfg, shipCents === 0) : '';
    if (sub) { sub.textContent = dt; show(sub, !!dt); }
    var shortEl = $('[data-hc-ship-short]', foot);
    if (shortEl) {
      var sh = dt.replace(/^.*?\baté\s+/i, '');
      if (sh === dt) sh = dt.replace(/^chega(\s+grátis)?\s+/i, '');
      shortEl.textContent = sh ? '· ' + sh : '';
    }
    var noticeTxt = info.notice || '';
    if (info.state === 'error') noticeTxt = 'Não encontramos opções de entrega para o CEP ' + formatCep(info.cep) + '. Confira o número.';
    if (notice) { notice.textContent = noticeTxt; show(notice, !!noticeTxt); }
    if (detail) detail.textContent = sel ? (shipCents === 0 ? 'Grátis' : m(root, shipCents)) : 'A calcular';

    // ganhou o frete grátis mas está com um frete pago escolhido: um aviso só, sem a faixa "Você ganhou"
    var freeRate = (info.rates || []).filter(function (r) { return rateCents(r) === 0; })[0] || null;
    var paidOverFree = !!(sel && shipCents > 0 && freeRate);
    var fsBox = $('[data-hc-fsbar]', root);
    if (fsBox && hasBar) show(fsBox, !!fsBox.innerHTML && !paidOverFree);
    var useFree = $('[data-hc-use-free]', foot);
    if (useFree) show(useFree, paidOverFree);
    var barAsks = !!(fsBox && !fsBox.hidden && fsBox.querySelector('[data-hc-ship-open]:not([data-hc-cep-btn])'));
    if (row) show(row, !(hasBar && reached && !paidOverFree && (!sel || shipCents === 0)) && !(barAsks && !sel && info.state !== 'loading'));
    if (fsSub) {
      var free = (info.rates || []).filter(function (r) { return rateCents(r) === 0; })[0];
      if (info.state === 'loading') fsSub.textContent = 'Calculando o prazo…';
      else if (sel && shipCents === 0) fsSub.textContent = deliveryText(sel, cfg, true) || rateName(sel);
      else if (sel) fsSub.textContent = 'Você escolheu ' + rateName(sel);
      else if (free) fsSub.textContent = deliveryText(free, cfg, true) || rateName(free);
      else fsSub.textContent = 'Informe o CEP para ver o prazo';
    }
    if (cepLabel) { cepLabel.textContent = info.cep ? 'CEP ' + formatCep(info.cep) : ''; show(cepLabel, !!info.cep); }
    if (cepBtn) cepBtn.innerHTML = info.cep ? 'Alterar' + svg('pencil', 13, 2) : 'Calcular';

    // total, PIX e parcelas
    var grand = total + shipCents;
    $$('[data-hc-total]', foot).forEach(function (el) { el.textContent = m(root, grand); });
    // PIX e parcelas: valores de Configuração de Preços (JSON no layout); o carrinho só decide se mostra
    var pc = priceConfig();
    var pixPct = foot.getAttribute('data-show-pix') === 'true' ? (parseFloat(pc.pix) || 0) : 0;
    var instMax = foot.getAttribute('data-show-inst') === 'true' ? (parseInt(pc.inst, 10) || 0) : 0;
    var instMin = Math.round(Number(pc.min) || 0);
    var showPix = pixOn(foot, pixPct);
    var pixTxt = showPix ? m(root, pixValue(foot, total, shipCents, pixPct)) : '';
    var n = instMax;
    if (instMin > 0) n = Math.min(instMax, Math.floor(grand / instMin));
    var showInst = n >= 2;
    var instTxt = showInst ? n + 'x de ' + m(root, Math.floor(grand / n)) : '';
    $$('[data-hc-pay]', foot).forEach(function (pay) {
      var pixWrap = $('[data-hc-pix-wrap]', pay), instWrap = $('[data-hc-inst-wrap]', pay);
      if (showPix) $('[data-hc-pix]', pay).textContent = pixTxt;
      if (showInst) {
        $('[data-hc-inst]', pay).textContent = instTxt;
        $('[data-hc-inst-pre]', pay).textContent = showPix ? 'ou ' : 'Em até ';
      }
      show(pixWrap, showPix); show(instWrap, showInst); show(pay, showPix || showInst);
    });
    $$('[data-hc-side-pay]', foot).forEach(function (sidePay) {
      var txt = '';
      if (showPix) {
        txt = '<strong>' + esc(pixTxt) + ' no PIX</strong>' + (showInst ? '<span class="hc-side__sep"> · </span><span class="hc-side__inst">' + esc(n + 'x ' + m(root, Math.floor(grand / n))) + '</span>' : '');
        sidePay.classList.add('is-pix');
      } else if (showInst) {
        txt = 'ou ' + esc(instTxt) + ' sem juros';
        sidePay.classList.remove('is-pix');
      }
      sidePay.innerHTML = txt;
      show(sidePay, !!txt);
    });
    // página do carrinho: barra fixa do celular
    var pb = $('[data-hc-pagebar]', root);
    if (pb) {
      var pbT = $('[data-hc-pagebar-total]', pb), pbP = $('[data-hc-pagebar-pay]', pb);
      if (pbT) pbT.textContent = m(root, grand);
      if (pbP) {
        var bPix = foot.getAttribute('data-show-pix') === 'true' ? (parseFloat(pc.pix) || 0) : 0;
        var bMax = foot.getAttribute('data-show-inst') === 'true' ? (parseInt(pc.inst, 10) || 0) : 0;
        var bMin = Math.round(Number(pc.min) || 0);
        var bN = bMin > 0 ? Math.min(bMax, Math.floor(grand / bMin)) : bMax;
        var bt = pixOn(foot, bPix) ? m(root, pixValue(foot, total, shipCents, bPix)) + ' no PIX' : (bN >= 2 ? 'ou ' + bN + 'x de ' + m(root, Math.floor(grand / bN)) : '');
        pbP.textContent = bt; show(pbP, !!bt);
      }
    }
    root._ship = info;
    if (isInlineShip(root)) renderRateList(root);
  }

  function isInlineShip(root) { return !!$('[data-hc-inline-ship]', root); }

  /* ----------------------------------------------------- folha de frete */

  function openSheet(root) {
    var sheet = $('[data-hc-sheet]', root);
    if (!sheet) return;
    if (isInlineShip(root)) {
      // página do carrinho: o campo de CEP já está no resumo
      var inp = $('[data-hc-cep-input]', sheet);
      try { sheet.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      setTimeout(function () { if (inp) inp.focus(); }, 250);
      return;
    }
    show(sheet, true);
    root.classList.add('has-sheet');
    var input = $('[data-hc-cep-input]', sheet);
    var cep = getCep();
    if (input) input.value = cep ? formatCep(cep) : '';
    renderRateList(root);
    setTimeout(function () { if (input && !cep) input.focus(); }, 60);
  }
  function closeSheet(root) {
    var sheet = $('[data-hc-sheet]', root);
    if (!sheet || sheet.hasAttribute('hidden') || isInlineShip(root)) return false;
    show(sheet, false);
    root.classList.remove('has-sheet');
    return true;
  }

  function renderRateList(root) {
    var box = $('[data-hc-rates]', root);
    if (!box) return;
    var info = root._ship || {};
    var cfg = cfgOf(root);
    if (!getCep()) { box.innerHTML = ''; return; }
    if (info.state === 'loading') { box.innerHTML = '<p class="hc-muted">Calculando opções de entrega…</p>'; return; }
    if (info.state === 'error') { box.innerHTML = '<p class="hc-error">Não encontramos opções de entrega para este CEP. Confira o número e tente de novo.</p>'; return; }
    var rates = info.rates || [];
    if (!rates.length) { box.innerHTML = ''; return; }
    var selKey = info.sel ? rateKey(info.sel) : '';
    box.innerHTML = rates.map(function (r, i) {
      var c = rateCents(r);
      var dt = deliveryText(r, cfg, c === 0);
      var on = rateKey(r) === selKey;
      return '<button type="button" class="hc-rate' + (on ? ' is-on' : '') + '" data-hc-rate="' + i + '" aria-pressed="' + on + '">' +
        '<span class="hc-rate__dot"></span>' +
        '<span class="hc-rate__info"><span class="hc-rate__name">' + esc(rateName(r)) + '</span>' +
        (dt ? '<span class="hc-rate__when' + (cfg.format === 'date' ? ' is-date' : '') + '">' + esc(dt) + '</span>' : '') + '</span>' +
        '<span class="hc-rate__price' + (c === 0 ? ' is-free' : '') + '">' + (c === 0 ? 'Grátis' : esc(m(root, c))) + '</span></button>';
    }).join('');
  }

  function calcFromSheet(root) {
    var input = $('[data-hc-cep-input]', root);
    var d = digits(input && input.value);
    var box = $('[data-hc-rates]', root);
    if (d.length !== 8) {
      if (box) box.innerHTML = '<p class="hc-error">Digite os 8 números do CEP.</p>';
      if (input) input.focus();
      return;
    }
    saveCep(d);
    track('hc_shipping_calculated', { uf: cepToUF(d) });
    $$('[data-hc-cart]').forEach(function (r) { updateShipping(r); });
    renderRateList(root);
  }

  function pickRate(root, idx) {
    var info = root._ship || {};
    var r = (info.rates || [])[idx];
    if (!r) return;
    persistRate(r, true);
    LS.set('hc_choice_had_free', hasFree(info.rates) ? '1' : '0');
    track('hc_shipping_selected', { name: rateName(r), price: rateCents(r) / 100 });
    $$('[data-hc-cart]').forEach(function (x) {
      var i2 = x._ship || {};
      if (i2.rates) paintShip(x, Object.assign({}, i2, { sel: r, notice: '' }));
    });
    closeSheet(root);
  }

  /* ---------------------------------------------------- Compre junto */

  var RECS;
  function recsConfig() {
    if (RECS) return RECS;
    var el = document.querySelector('script[data-hc-recs-config]');
    try { RECS = el ? JSON.parse(el.textContent) : null; } catch (e) { RECS = null; }
    return RECS;
  }

  // Carrinho vazio: mais vendidos da loja
  function loadBest(root) {
    var wrap = $('[data-hc-best]', root);
    var st = $('[data-hc-state]', root);
    if (!wrap || !st) return;
    var count = parseInt(st.getAttribute('data-count'), 10) || 0;
    if (count || root.getAttribute('data-empty-best') !== 'true') { show(wrap, false); return; }
    if (root._bestLoaded) { show(wrap, !!$('[data-hc-best-list]', wrap).children.length); return; }
    root._bestLoaded = true;
    var url = cfgOf(root).root.replace(/\/?$/, '/') + 'collections/all?sort_by=best-selling&section_id=hc-cart-recs';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var res = doc.querySelector('[data-hc-recs-result]');
      var list = $('[data-hc-best-list]', wrap);
      if (!res || !res.children.length || !list) { show(wrap, false); return; }
      list.innerHTML = res.innerHTML;
      bestCards(root, list);
      show(wrap, !(parseInt(($('[data-hc-state]', root) || st).getAttribute('data-count'), 10) || 0));
    }).catch(function () { show(wrap, false); });
  }

  // endereço da lista para as origens fixas (mais vendidos, produtos escolhidos, coleção)
  function recsListUrl(root, rc) {
    var base = cfgOf(root).root.replace(/\/?$/, '/');
    if (rc.source === 'products') {
      var ids = String(rc.ids || '').split(',').filter(Boolean);
      if (!ids.length) return '';
      return base + 'search?type=product&options[unavailable_products]=hide&q=' + encodeURIComponent(ids.map(function (i) { return 'id:' + i; }).join(' OR ')) + '&section_id=hc-cart-recs';
    }
    if (rc.source === 'collection') return rc.coll ? base + 'collections/' + encodeURIComponent(rc.coll) + '?section_id=hc-cart-recs' : '';
    return base + 'collections/all?sort_by=best-selling&section_id=hc-cart-recs';
  }

  function loadRecs(root) {
    var cfg = cfgOf(root);
    var rc = recsConfig();
    var wrap = $('[data-hc-recs]', root);
    var st = $('[data-hc-state]', root);
    if (!wrap || !st) return;
    if (!rc || !rc.show) { show(wrap, false); return; }
    cfg.recs = rc.source || 'related';
    var titleEl = $('[data-hc-recs-title]', wrap);
    var tt = (rc.title || '').trim() || 'Compre junto';
    if (titleEl && titleEl.textContent !== tt) titleEl.textContent = tt;
    var count = parseInt(st.getAttribute('data-count'), 10) || 0;
    var pids = st.getAttribute('data-pids') || '';
    var first = st.getAttribute('data-first-pid');
    if (!count) { show(wrap, false); root._recsKey = ''; return; }
    var key = cfg.recs + '|' + pids;
    if (root._recsKey === key) return;
    root._recsKey = key;
    var base = cfg.root.replace(/\/?$/, '/');
    var bestUrl = base + 'collections/all?sort_by=best-selling&section_id=hc-cart-recs';
    var auto = cfg.recs === 'related' || cfg.recs === 'complementary';
    var url;
    if (auto) {
      url = first ? cfg.recsUrl + '?section_id=hc-cart-recs&product_id=' + first + '&limit=10&intent=' + cfg.recs : '';
    } else {
      url = recsListUrl(root, rc);
    }
    var coll = st.getAttribute('data-first-coll');
    var collUrl = coll ? base + 'collections/' + encodeURIComponent(coll) + '?section_id=hc-cart-recs' : '';
    function grab(u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var res = doc.querySelector('[data-hc-recs-result]');
        return res && res.children.length ? res.innerHTML : '';
      }).catch(function () { return ''; });
    }
    (url ? grab(url) : Promise.resolve('')).then(function (html) {
      // sem sugestões do Shopify para este produto: usa a coleção do produto
      if (!html && collUrl && auto) return grab(collUrl);
      return html;
    }).then(function (html) {
      // ainda vazio (produto sem coleção ou todos já no carrinho): mais vendidos da loja
      if (!html && auto) return grab(bestUrl);
      return html;
    }).then(function (html) {
      if (root._recsKey !== key) return;
      var list = $('[data-hc-recs-list]', wrap);
      if (!html || !list) { show(wrap, false); return; }
      list.innerHTML = html;
      recsStyle(wrap, rc);
      show(wrap, true);
    });
  }


  /* ------------------------------------------------- oferta no carrinho */

  var OFFER;
  function offerCfg() {
    if (OFFER) return OFFER;
    var el = document.getElementById('hc-cart-offer');
    try { OFFER = el ? JSON.parse(el.textContent) : null; } catch (e) { OFFER = null; }
    return OFFER;
  }
  function detailsTxt(el, open) {
    var side = el.classList.contains('hc-side__toggle');
    return side ? (open ? 'ocultar resumo' : 'ver resumo') : (open ? 'Ocultar detalhes' : 'Ver detalhes');
  }
  function typeCls(t) { return 'hb-btn t4s-btn-color-' + String(t || 'primary').replace(/[^a-z0-9]/g, ''); }
  function setVars(el, map) {
    if (!el) return;
    Object.keys(map).forEach(function (k) { if (map[k] !== '' && map[k] != null) el.style.setProperty(k, map[k]); });
  }
  function offerVars(el, o) {
    var s = (o && o.style) || {};
    setVars(el, { '--hc-of-bg': s.bg, '--hc-of-bd': s.bd, '--hc-of-bw': (s.bw != null ? s.bw : 2) + 'px', '--hc-of-r': (s.r != null ? s.r : 12) + 'px', '--hc-of-tag-bg': s.tagBg, '--hc-of-tag-fg': s.tagFg, '--hc-of-hi': s.hi });
  }
  function cartPids(root) {
    var st = $('[data-hc-state]', root);
    var map = {};
    ((st && st.getAttribute('data-pids')) || '').split(',').forEach(function (x) { if (x) map[x] = true; });
    return map;
  }
  function offerRow(root, p, opts) {
    var hasCmp = p.compare > p.price;
    var btn;
    var label = opts.btnText || 'Adicionar';
    if (p.single) {
      btn = '<button type="button" class="hc-ofr__btn ' + typeCls(opts.btn) + '" data-hc-offer-add="' + esc(p.vid) + '"' + (opts.swap ? ' data-hc-offer-swap="' + esc(opts.swap) + '"' : '') +
        ' aria-label="' + esc(label + ': ' + p.title) + '">' + esc(label) + '</button>';
    } else {
      btn = '<a href="' + esc(p.url) + '" class="hc-ofr__btn ' + typeCls(opts.btn) + '" data-action-quickshop data-id="' + esc(p.id) + '" data-no-instant rel="nofollow" aria-label="' + esc('Escolher opções de ' + p.title) + '">' + esc(label) + '</a>';
    }
    return '<div class="hc-ofr__row">' +
      '<a class="hc-ofr__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="60" height="75">' : '') + '</a>' +
      '<span class="hc-ofr__body">' +
        (opts.tag ? '<span class="hc-ofr__tag">' + esc(opts.tag) + '</span>' : '') +
        '<a class="hc-ofr__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="hc-ofr__price"><strong>' + m(root, p.price) + '</strong>' + (hasCmp ? ' <s><span class="hc-sr">Preço anterior </span>' + m(root, p.compare) + '</s>' : '') + '</span>' +
        (hasCmp ? '<span class="hc-ofr__save">Economize ' + m(root, p.compare - p.price) + '</span>' : '') +
      '</span>' + (opts.inlineBtn ? btn : '') +
    '</div>' + (opts.inlineBtn ? '' : '<div class="hc-ofr__actions">' + (opts.dismiss ? '<button type="button" class="hc-link hc-ofr__no" data-hc-offer-dismiss>Não, obrigado</button>' : '<span></span>') + btn + '</div>');
  }
  function offerHtml(root, o) {
    var inCart = cartPids(root);
    var avail = function (p) { return p && p.available && !inCart[String(p.id)]; };
    if (o.auto) {
      var hit = (o.kits || []).filter(function (k) { return inCart[String(k.trigger)] && avail(k.kit); })[0];
      if (hit) {
        return { kind: 'kit', html: '<section class="hc-ofr" aria-label="' + esc(o.tagKit) + '">' +
          offerRow(root, hit.kit, { tag: o.tagKit, btn: o.btn, btnText: o.swapBtn, swap: hit.trigger, dismiss: o.dismiss }) + '</section>' };
      }
    }
    var other = o.other || 'none';
    if (other === 'kit_fixo' && avail(o.fixed)) {
      return { kind: 'kit_fixo', html: '<section class="hc-ofr" aria-label="' + esc(o.tagKit) + '">' + offerRow(root, o.fixed, { tag: o.tagKit, btn: o.btn, btnText: o.addBtn, dismiss: o.dismiss }) + '</section>' };
    }
    if (other === 'kit_colecao' || other === 'oferta') {
      var list = (other === 'oferta' ? o.offer : o.coll) || [];
      list = list.filter(avail).slice(0, other === 'oferta' ? 4 : (o.collMax || 3));
      if (!list.length) return null;
      var tag = other === 'oferta' ? o.tagOffer : o.tagKit;
      var head = '<div class="hc-ofr__head"><span class="hc-ofr__tag">' + esc(tag) + '</span>' + (o.dismiss ? '<button type="button" class="hc-link hc-ofr__no" data-hc-offer-dismiss>Não, obrigado</button>' : '') + '</div>';
      if (other === 'oferta' && (o.offerTitle || o.offerText)) {
        head += (o.offerTitle ? '<span class="hc-ofr__title">' + esc(o.offerTitle) + '</span>' : '') + (o.offerText ? '<span class="hc-ofr__text">' + esc(o.offerText) + '</span>' : '');
      }
      return { kind: other, html: '<section class="hc-ofr hc-ofr--list" aria-label="' + esc(tag) + '">' + head + '<div class="hc-ofr__items">' +
        list.map(function (p) { return '<div class="hc-ofr__item">' + offerRow(root, p, { btn: o.btn, btnText: o.addBtn, inlineBtn: true }) + '</div>'; }).join('') + '</div></section>' };
    }
    if (other === 'banner' && o.banner && o.banner.img) {
      var b = o.banner;
      // no carrinho lateral (estreito) usa sempre a imagem do celular
      var pic = cfgOf(root).mode === 'drawer' ? '<img src="' + esc(b.imgMob || b.img) + '" alt="' + esc(b.alt || '') + '" loading="lazy">' :
        '<picture><source media="(max-width: 749px)" srcset="' + esc(b.imgMob || b.img) + '"><img src="' + esc(b.img) + '" alt="' + esc(b.alt || '') + '" loading="lazy"' + (b.w ? ' width="' + b.w + '" height="' + b.h + '"' : '') + '></picture>';
      return { kind: 'banner', html: b.url ? '<a class="hc-ofr-banner" href="' + esc(b.url) + '">' + pic + '</a>' : '<div class="hc-ofr-banner">' + pic + '</div>' };
    }
    return null;
  }
  function renderOffer(root) {
    var o = offerCfg();
    var cfg = cfgOf(root);
    var slots = $$('[data-hc-offer-slot]', root);
    if (!slots.length) return;
    var st = $('[data-hc-state]', root);
    var count = st ? parseInt(st.getAttribute('data-count'), 10) || 0 : 0;
    var want = null;
    if (o && o.on !== false && count && SS.get('hc_offer_off') !== '1') {
      if (cfg.mode === 'page' ? o.page : o.drawer) want = cfg.mode === 'page' ? 'page' : (o.drawerPos === 'below' ? 'below' : 'above');
    }
    var key = want + '|' + (st ? st.getAttribute('data-pids') : '');
    if (root._offerKey === key) return;
    root._offerKey = key;
    var res = want ? offerHtml(root, o) : null;
    slots.forEach(function (slot) {
      var on = !!res && slot.getAttribute('data-hc-offer-slot') === want;
      if (on) { slot.innerHTML = res.html; offerVars(slot, o); }
      else slot.innerHTML = '';
      show(slot, on);
    });
  }
  function offerAdd(root, btn) {
    if (S.busy) return;
    var vid = Number(btn.getAttribute('data-hc-offer-add'));
    var trig = btn.getAttribute('data-hc-offer-swap');
    track(trig ? 'hc_offer_kit_swap' : 'hc_offer_add', { variant_id: vid });
    if (!trig) { addVariant(root, vid, btn); return; }
    var upd = {};
    $$('[data-hc-item]', root).forEach(function (el) {
      if (el.getAttribute('data-pid') === String(trig) && !el.hasAttribute('data-hc-gift-line')) upd[el.getAttribute('data-key')] = 0;
    });
    setBusy(root, true);
    btn.disabled = true;
    postJSON(cartRoute('update.js'), { updates: upd }).then(function () {
      setBusy(root, false);
      return addVariant(root, vid, btn);
    }).catch(function () { setBusy(root, false); btn.disabled = false; });
  }

  /* --------------------------------------- carrinho vazio: kits e compre junto */

  function loadEmptyExtras(root) {
    var st = $('[data-hc-state]', root);
    if (!st) return;
    var count = parseInt(st.getAttribute('data-count'), 10) || 0;
    var kitsWrap = $('[data-hc-ekits]', root);
    var crossWrap = $('[data-hc-ecross]', root);
    if (kitsWrap) {
      var o = offerCfg();
      var on = !count && root.getAttribute('data-empty-kits') === 'true' && o;
      var html = '';
      if (on) {
        var seen = {};
        var list = (o.kits || []).map(function (k) { return k.kit; }).concat(o.fixed ? [o.fixed] : [], o.coll || [])
          .filter(function (p) { if (!p || !p.available || seen[p.id]) return false; seen[p.id] = true; return true; }).slice(0, 4);
        html = list.map(function (p) { return '<div class="hc-ofr hc-ofr--one">' + offerRow(root, p, { tag: o.tagKit, btn: o.btn, btnText: o.addBtn, inlineBtn: true }) + '</div>'; }).join('');
      }
      var kl = $('[data-hc-ekits-list]', kitsWrap);
      if (kl && kl.innerHTML !== html) { kl.innerHTML = html; offerVars(kitsWrap, o); }
      show(kitsWrap, !!html);
    }
    if (crossWrap) {
      var rc = recsConfig();
      var ok = !count && root.getAttribute('data-empty-cross') === 'true' && rc && rc.show && (rc.source === 'products' || rc.source === 'collection');
      if (!ok) { show(crossWrap, false); return; }
      recsStyle(crossWrap, rc);
      if (root._ecrossLoaded) { show(crossWrap, !!$('[data-hc-ecross-list]', crossWrap).children.length); return; }
      root._ecrossLoaded = true;
      var eurl = recsListUrl(root, rc);
      if (!eurl) { show(crossWrap, false); return; }
      fetch(eurl, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
          var doc = new DOMParser().parseFromString(h || '', 'text/html');
          var res = doc.querySelector('[data-hc-recs-result]');
          var list = $('[data-hc-ecross-list]', crossWrap);
          if (!res || !res.children.length || !list) { show(crossWrap, false); return; }
          list.innerHTML = res.innerHTML;
          recsStyle(crossWrap, rc);
          var c2 = parseInt(($('[data-hc-state]', root) || st).getAttribute('data-count'), 10) || 0;
          show(crossWrap, !c2);
        }).catch(function () { show(crossWrap, false); });
    }
  }
  function recsStyle(wrap, rc) {
    if (!wrap || !rc) return;
    var s = rc.style || {};
    var blocks = rc.layout === 'blocks';
    wrap.classList.toggle('is-blocks', blocks);
    var bcls = 't4s-btn-color-' + String(rc.btn || 'secondary').replace(/[^a-z0-9]/g, '');
    var lim = parseInt(rc.limit, 10) || 6;
    $$('.hc-card', wrap).forEach(function (c, i) {
      if (i >= lim) { c.remove(); return; }
      c.classList.toggle('hc-card--row', blocks);
      var tag = $('.hc-card__tag', c);
      if (tag) { tag.textContent = rc.tag || ''; show(tag, blocks && !!rc.tag); }
      var sv = $('.hc-card__save', c);
      if (sv) show(sv, blocks);
      var b = $('.hc-card__add', c);
      if (b) { b.className = b.className.replace(/t4s-btn-color-[a-z0-9]+/, bcls); b.innerHTML = '<span class="hc-card__plus" aria-hidden="true">+</span><span class="hc-card__addtxt"> Adicionar</span>'; }
    });
    setVars(wrap, { '--hc-rc-bg': s.bg, '--hc-rc-bd': s.bd, '--hc-rc-bw': (s.bw != null ? s.bw : 1) + 'px', '--hc-rc-r': (s.r != null ? s.r : 10) + 'px', '--hc-rc-tag-bg': s.tagBg, '--hc-rc-tag-fg': s.tagFg, '--hc-rc-hi': s.hi });
  }
  // Mais vendidos do carrinho vazio: sempre em cartões, com o botão escolhido em Carrinho vazio
  function bestCards(root, list) {
    var t = 't4s-btn-color-' + String(root.getAttribute('data-empty-btn') || 'secondary').replace(/[^a-z0-9]/g, '');
    $$('.hc-card', list).forEach(function (c) {
      c.classList.remove('hc-card--row');
      var b = $('.hc-card__add', c);
      if (b) { b.className = b.className.replace(/t4s-btn-color-[a-z0-9]+/, t); b.innerHTML = '<span class="hc-card__plus" aria-hidden="true">+</span><span class="hc-card__addtxt"> Adicionar</span>'; }
    });
  }
  function giftStyle() {
    var G = goals();
    var g = (G && G.giftStyle) || null;
    if (!g) return;
    $$('[data-hc-cart]').forEach(function (r) {
      setVars(r, { '--hc-g-accent': g.accent, '--hc-g-tag-bg': g.tagBg, '--hc-g-tag-fg': g.tagFg, '--hc-g-free': g.free, '--hc-g-line': g.line, '--hc-g-flash': g.flash, '--hc-g-box-bg': g.boxBg, '--hc-g-box-bd': g.boxBd, '--hc-g-box-bw': (g.boxBw != null ? g.boxBw : 2) + 'px', '--hc-g-r': (g.r != null ? g.r : 10) + 'px' });
    });
  }
  function giftBtnCls() {
    var G = goals();
    return typeCls((G && G.giftStyle && G.giftStyle.btn) || 'custom1');
  }

  /* ---------------------------------------------------------- similares */

  function normProduct(p, fromJs) {
    var variants = (p.variants || []).map(function (v) {
      return {
        id: v.id,
        available: v.available !== false,
        price: fromJs ? Number(v.price) : Math.round(parseFloat(v.price) * 100),
        options: v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })
      };
    });
    var avail = variants.filter(function (v) { return v.available; });
    var img = fromJs ? (p.featured_image || (p.images && p.images[0])) : (p.images && p.images[0] && p.images[0].src);
    if (img && typeof img === 'object') img = img.src;
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
    return {
      id: p.id, title: p.title, handle: p.handle,
      url: p.url || ('/products/' + p.handle),
      type: p.type || p.product_type || '',
      tags: tags,
      price: avail.length ? Math.min.apply(null, avail.map(function (v) { return v.price; })) : (fromJs ? p.price : 0),
      available: avail.length > 0,
      variants: variants,
      single: variants.length <= 1,
      image: img ? (img.indexOf('data:') === 0 ? img : img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240') : ''
    };
  }

  function loadSimilars(panel) {
    if (panel._loaded) return;
    panel._loaded = true;
    var root = panel.closest('[data-hc-cart]');
    var cfg = cfgOf(root);
    var list = $('[data-hc-similar-list]', panel);
    var data = {};
    try { data = JSON.parse(panel.getAttribute('data-hc-similar') || '{}'); } catch (e) {}
    var st = $('[data-hc-state]', root);
    var inCart = (st && st.getAttribute('data-pids') || '').split(',').filter(Boolean).map(Number);
    var range = cfg.similar === 'any' ? Infinity : (parseInt(cfg.similar, 10) || 30) / 100;
    var base = Number(data.price) || 0;

    var reqs = [
      fetch(cfg.recsUrl + '.json?product_id=' + data.pid + '&limit=10&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).map(function (p) { return normProduct(p, true); }); })
        .catch(function () { return []; })
    ];
    if (data.coll) {
      reqs.push(fetch(cfg.root.replace(/\/?$/, '/') + 'collections/' + encodeURIComponent(data.coll) + '/products.json?limit=40', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).map(function (p) { var n = normProduct(p, false); n.inColl = true; return n; }); })
        .catch(function () { return []; }));
    }
    Promise.all(reqs).then(function (groups) {
      var byId = {};
      groups.forEach(function (g) {
        g.forEach(function (p) {
          if (byId[p.id]) { byId[p.id].inColl = byId[p.id].inColl || p.inColl; byId[p.id].related = true; }
          else byId[p.id] = p;
        });
      });
      var myTags = (data.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var myOpts = (data.opts || []).map(function (o) { return String(o).toLowerCase(); });
      var picks = Object.keys(byId).map(function (k) { return byId[k]; }).filter(function (p) {
        if (!p.available || p.id === data.pid || inCart.indexOf(p.id) > -1) return false;
        if (data.type && p.type && p.type !== data.type) return false;
        if (range !== Infinity && base > 0 && Math.abs(p.price - base) / base > range) return false;
        return true;
      }).map(function (p) {
        var score = 0;
        if (data.type && p.type === data.type) score += 3;
        var common = p.tags.filter(function (t) { return myTags.indexOf(String(t).toLowerCase()) > -1; }).length;
        score += Math.min(3, common);
        if (p.inColl) score += 2;
        if (base > 0) score += 2 * Math.max(0, 1 - Math.abs(p.price - base) / base);
        var match = null;
        if (myOpts.length) {
          match = p.variants.filter(function (v) {
            return v.available && v.options.some(function (o) { return myOpts.indexOf(String(o).toLowerCase()) > -1; });
          })[0] || null;
          if (match) score += 1;
        }
        var only = p.variants.filter(function (v) { return v.available; });
        p.pick = p.single ? only[0] : (match && p.variants.length && myOpts.length && match.options.length === myOpts.length ? match : null);
        p.score = score;
        return p;
      }).sort(function (a, b) { return b.score - a.score; }).slice(0, cfg.similarCount);

      if (!picks.length) {
        list.innerHTML = '<span class="hc-muted">Nenhum parecido disponível agora.</span>';
        return;
      }
      list.innerHTML = picks.map(function (p) {
        var btn = p.pick
          ? '<button type="button" class="hc-btn-dark hc-btn-xs ' + btnCls() + '" data-hc-swap="' + p.pick.id + '">Trocar</button>'
          : '<a href="' + esc(p.url) + '" class="hc-btn-dark hc-btn-xs ' + btnCls() + '" data-action-quickshop data-id="' + p.id + '" data-no-instant rel="nofollow">Escolher</a>';
        return '<div class="hc-mini">' +
          '<a class="hc-mini__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="hc-mini__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="hc-mini__price">' + esc(m(root, p.price)) + '</span>' + btn + '</div>';
      }).join('');
    });
  }

  function swapItem(btn) {
    var item = btn.closest('[data-hc-item]');
    var root = btn.closest('[data-hc-cart]');
    if (!item || S.busy) return;
    var key = item.getAttribute('data-key');
    addVariant(root, btn.getAttribute('data-hc-swap'), btn, function () {
      setBusy(root, true);
      return postJSON(cartRoute('change.js'), { id: key, quantity: 0, sections: sectionsParam(), sections_url: window.location.pathname })
        .then(function (res) { setBusy(root, false); applySections(res.json && res.json.sections); })
        .catch(function () { setBusy(root, false); refreshFromServer(); });
    });
  }

  /* ------------------------------------------------- passagem de render */

  function process(root) {
    var st = $('[data-hc-state]', root);
    if (!st) return;
    var cfg = cfgOf(root);

    // contador do cabeçalho
    var count = parseInt(st.getAttribute('data-count'), 10) || 0;
    var label = $('[data-hc-count-label]', root);
    if (label) {
      var lt = '(' + count + (count === 1 ? ' item)' : ' itens)');
      if (label.textContent !== lt) label.textContent = lt;
      show(label, count > 0);
    }
    root.classList.toggle('is-empty', count === 0);
    var express = $('.hc-express', root);
    if (express) show(express, count > 0);

    if (!st._hcDone) {
      st._hcDone = true;
      // item novo ou quantidade que subiu por fora (ex.: comprar na página de produto)
      var prev = root._qty;
      var now = {};
      var flashed = [];
      $$('[data-hc-item]', root).forEach(function (el) {
        var k = el.getAttribute('data-key');
        var q = parseInt(el.getAttribute('data-qty'), 10) || 0;
        now[k] = q;
        if (prev && (prev[k] == null || (q > prev[k] && S.lastOwnKey !== k))) flashed.push(el);
        if (S.similarOpen[k]) {
          var panel = $('[data-hc-similar-panel]', el);
          var tg = $('[data-hc-similar-toggle]', el);
          if (panel) { show(panel, true); loadSimilars(panel); }
          if (tg) { tg.setAttribute('aria-expanded', 'true'); tg.textContent = 'Fechar similares'; }
        }
      });
      root._qty = now;
      S.lastOwnKey = null;
      if (flashed.length) {
        var scroller = $('[data-hc-scroll]', root);
        if (scroller && cfg.mode === 'drawer') { try { scroller.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { scroller.scrollTop = 0; } }
        flashed.forEach(function (el) {
          el.classList.add('is-new');
          setTimeout(function () { el.classList.remove('is-new'); }, 1900);
        });
      }

      // estado do cupom (aberto/fechado) entre atualizações
      $$('[data-hc-coupon]', root).forEach(function (box) {
        var form = $('[data-hc-coupon-form]', box);
        if (!form) return;
        var open = S.couponOpen == null ? !cfg.couponCollapsed : S.couponOpen;
        setCouponOpen(box, open);
      });
      loadRecs(root);
      loadBest(root);
      loadEmptyExtras(root);
      giftStyle();
    }
    renderOffer(root);

    var foot = $('[data-hc-foot]', root);
    var fslot = $('[data-hc-fsbar-slot]', root);
    if (fslot) {
      // página do carrinho: a barra de frete grátis fica acima dos produtos
      var fresh = foot && $('[data-hc-fsbar]', foot);
      if (fresh) { fslot.innerHTML = ''; fslot.appendChild(fresh); }
      else if (!foot) fslot.innerHTML = '';
    }
    var pbar = $('[data-hc-pagebar]', root);
    if (pbar) { show(pbar, count > 0); watchPagebar(root, pbar); }
    if (isInlineShip(root)) {
      var cinp = $('[data-hc-cep-input]', root);
      if (cinp && !cinp.value && getCep()) cinp.value = formatCep(getCep());
    }
    if (foot && !foot._hcDone) {
      foot._hcDone = true;
      var details = $('[data-hc-details]', foot);
      var dt = $('[data-hc-details-toggle]', foot);
      if (details) { show(details, S.detailsOpen); }
      if (dt) { dt.textContent = detailsTxt(dt, S.detailsOpen); dt.setAttribute('aria-expanded', String(S.detailsOpen)); }
      updateShipping(root);
      syncGifts(root);
    }
  }

  // barra fixa do celular: some quando o resumo (com o botão) está na tela
  function watchPagebar(root, bar) {
    if (bar._hcWatch || !('IntersectionObserver' in window)) return;
    var sum = $('#hc-cart-summary', root) || $('.hc-cart__foot', root);
    if (!sum) return;
    bar._hcWatch = true;
    new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { bar.classList.toggle('is-off', en.isIntersecting); });
    }, { threshold: 0.15 }).observe(sum);
  }

  function visible(root) {
    if (cfgOf(root).mode === 'page') return true;
    var d = document.getElementById('t4s-mini_cart');
    return !!(d && d.getAttribute('aria-hidden') === 'false');
  }

  function setCouponOpen(box, open) {
    var form = $('[data-hc-coupon-form]', box);
    var tg = $('[data-hc-coupon-toggle]', box);
    var txt = $('[data-hc-coupon-toggle-txt]', box);
    show(form, open);
    if (tg) tg.setAttribute('aria-expanded', String(open));
    if (txt) txt.textContent = open ? 'Fechar' : 'Adicionar cupom ›';
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = (window.requestAnimationFrame || setTimeout)(function () {
      raf = 0;
      $$('[data-hc-cart]').forEach(process);
    });
  }

  /* ------------------------------------------------------------ eventos */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-hc-cart]');
    if (!root) return;
    var el;

    if ((el = t.closest('[data-hc-gift-open]'))) {
      e.preventDefault();
      var gp = giftPrizes().filter(function (x) { return x.id === el.getAttribute('data-hc-gift-open'); })[0];
      if (gp) openGiftModal(root, gp);
      return;
    }
    if ((el = t.closest('[data-hc-gift-swap]'))) {
      e.preventDefault();
      var gl = el.closest('[data-hc-gift-line]');
      var gp2 = giftPrizes().filter(function (x) { return x.id === gl.getAttribute('data-hc-gift-line'); })[0];
      if (gp2) openGiftModal(root, gp2, gl.getAttribute('data-vid'));
      return;
    }
    if ((el = t.closest('[data-hc-gift-remove]'))) {
      e.preventDefault();
      var gl2 = el.closest('[data-hc-gift-line]');
      giftDeclined(gl2.getAttribute('data-hc-gift-line'), true);
      removeGiftLines(root, [gl2.getAttribute('data-key')]);
      return;
    }
    if ((el = t.closest('[data-hc-gift-pick]'))) {
      e.preventDefault();
      var stg = root._gift; if (!stg) return;
      stg.pick = Number(el.getAttribute('data-hc-gift-pick'));
      var o = giftOptions(stg.prize).filter(function (x) { return x.g.id === stg.pick; })[0];
      stg.vid = o && o.vars.length === 1 ? o.vars[0].id : null;
      renderGiftList(root);
      return;
    }
    if ((el = t.closest('[data-hc-gift-var]'))) { e.preventDefault(); if (root._gift) { root._gift.vid = el.getAttribute('data-hc-gift-var'); renderGiftList(root); } return; }
    if ((el = t.closest('[data-hc-gift-confirm]'))) { e.preventDefault(); confirmGift(root); return; }
    if ((el = t.closest('[data-hc-gmodal-close]'))) { e.preventDefault(); closeGiftModal(root); return; }
    if ((el = t.closest('[data-hc-vmodal-close]'))) { e.preventDefault(); closeVarModal(root); return; }
    if ((el = t.closest('[data-hc-var-opt]'))) {
      e.preventDefault();
      if (root._var) { root._var.sel[parseInt(el.getAttribute('data-hc-var-opt'), 10)] = el.getAttribute('data-hc-var-val'); renderVarModal(root); }
      return;
    }
    if ((el = t.closest('[data-hc-var-add]'))) { e.preventDefault(); confirmVar(root, el); return; }
    if ((el = t.closest('[data-hc-tier]'))) { e.preventDefault(); openTip(root, parseInt(el.getAttribute('data-hc-tier'), 10), true); return; }
    if ((el = t.closest('[data-hc-tip-close]'))) { e.preventDefault(); closeTip(root); return; }
    if (root._tipPinned && !t.closest('[data-hc-tip]')) closeTip(root);

    if ((el = t.closest('[data-hc-qty-plus]'))) {
      e.preventDefault();
      var it = el.closest('[data-hc-item]');
      var q = parseInt(it.getAttribute('data-qty'), 10) || 0;
      var step = parseInt(it.getAttribute('data-step'), 10) || 1;
      var max = parseInt(it.getAttribute('data-max'), 10) || 9999;
      if (q + step > max) return;
      changeLine(it, q + step);
      return;
    }
    if ((el = t.closest('[data-hc-qty-minus]'))) {
      e.preventDefault();
      var it2 = el.closest('[data-hc-item]');
      var q2 = parseInt(it2.getAttribute('data-qty'), 10) || 0;
      var step2 = parseInt(it2.getAttribute('data-step'), 10) || 1;
      var min = parseInt(it2.getAttribute('data-min'), 10) || 1;
      if (q2 - step2 < min) return;
      changeLine(it2, q2 - step2);
      return;
    }
    if ((el = t.closest('[data-hc-remove]'))) {
      e.preventDefault();
      changeLine(el.closest('[data-hc-item]'), 0);
      return;
    }
    if ((el = t.closest('[data-hc-coupon-toggle]'))) {
      e.preventDefault();
      var box = el.closest('[data-hc-coupon]');
      var open = el.getAttribute('aria-expanded') !== 'true';
      S.couponOpen = open;
      setCouponOpen(box, open);
      if (open) { var inp = $('[data-hc-coupon-input]', box); if (inp) setTimeout(function () { inp.focus(); }, 30); }
      return;
    }
    if ((el = t.closest('[data-hc-coupon-apply]'))) { e.preventDefault(); applyCoupon(el.closest('[data-hc-coupon]')); return; }
    if ((el = t.closest('[data-hc-coupon-remove]'))) { e.preventDefault(); removeCoupon(el); return; }
    if ((el = t.closest('[data-hc-details-toggle]'))) {
      e.preventDefault();
      S.detailsOpen = !S.detailsOpen;
      show($('[data-hc-details]', root), S.detailsOpen);
      el.textContent = detailsTxt(el, S.detailsOpen);
      el.setAttribute('aria-expanded', String(S.detailsOpen));
      return;
    }
    if ((el = t.closest('[data-hc-use-free]'))) {
      e.preventDefault();
      var inf = root._ship || {};
      var fr = (inf.rates || []).filter(function (r) { return rateCents(r) === 0; })[0];
      if (fr) {
        persistRate(fr, true);
        LS.set('hc_choice_had_free', '1');
        $$('[data-hc-cart]').forEach(function (x) { var i2 = x._ship || {}; if (i2.rates) paintShip(x, Object.assign({}, i2, { sel: fr, notice: '' })); });
      }
      return;
    }
    if ((el = t.closest('[data-hc-ship-open]'))) { e.preventDefault(); openSheet(root); return; }
    if ((el = t.closest('[data-hc-sheet-close]'))) { e.preventDefault(); closeSheet(root); return; }
    if ((el = t.closest('[data-hc-cep-calc]'))) { e.preventDefault(); calcFromSheet(root); return; }
    if ((el = t.closest('[data-hc-rate]'))) { e.preventDefault(); pickRate(root, parseInt(el.getAttribute('data-hc-rate'), 10)); return; }
    if ((el = t.closest('[data-hc-offer-add]'))) { e.preventDefault(); offerAdd(root, el); return; }
    if ((el = t.closest('[data-hc-offer-dismiss]'))) { e.preventDefault(); SS.set('hc_offer_off', '1'); root._offerKey = null; $$('[data-hc-cart]').forEach(function (r) { r._offerKey = null; renderOffer(r); }); track('hc_offer_dismiss', {}); return; }
    if ((el = t.closest('[data-hc-add]'))) { e.preventDefault(); track('hc_cross_sell_add', { variant_id: Number(el.getAttribute('data-hc-add')), list: el.closest('.hc-cart.is-empty') ? 'mais_vendidos' : 'compre_junto' }); addVariant(root, el.getAttribute('data-hc-add'), el); return; }
    if ((el = t.closest('[data-hc-swap]'))) { e.preventDefault(); track('hc_sold_out_swap', { variant_id: Number(el.getAttribute('data-hc-swap')) }); swapItem(el); return; }
    if ((el = t.closest('[data-hc-similar-toggle]'))) {
      e.preventDefault();
      var item = el.closest('[data-hc-item]');
      var panel = $('[data-hc-similar-panel]', item);
      if (!panel) return;
      var opening = panel.hasAttribute('hidden');
      show(panel, opening);
      el.setAttribute('aria-expanded', String(opening));
      el.textContent = opening ? 'Fechar similares' : 'Ver similares';
      S.similarOpen[item.getAttribute('data-key')] = opening;
      if (opening) loadSimilars(panel);
      return;
    }
    if ((el = t.closest('[data-hc-note-toggle]'))) {
      e.preventDefault();
      var body = $('[data-hc-note-body]', root);
      var opening2 = body.hasAttribute('hidden');
      show(body, opening2);
      el.setAttribute('aria-expanded', String(opening2));
      var nt = $('[data-hc-note-toggle-txt]', el);
      if (nt) nt.textContent = opening2 ? 'Fechar' : 'Adicionar ›';
      if (opening2) { var ta = $('[data-hc-note]', root); if (ta) ta.focus(); }
      return;
    }
    if ((el = t.closest('[data-hc-agree]'))) {
      show($('[data-hc-agree-err]', root), false);
    }
  });

  // Passar o mouse no marcador da barra mostra o detalhe do prêmio (computador)
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) {
    document.addEventListener('mouseover', function (e) {
      var d = e.target && e.target.closest && e.target.closest('[data-hc-tier]');
      if (!d) return;
      var root = d.closest('[data-hc-cart]');
      if (root && !root._tipPinned) openTip(root, parseInt(d.getAttribute('data-hc-tier'), 10), false);
    });
    document.addEventListener('mouseout', function (e) {
      var d = e.target && e.target.closest && e.target.closest('[data-hc-tier]');
      if (!d) return;
      var root = d.closest('[data-hc-cart]');
      if (root && !root._tipPinned) closeTip(root);
    });
  }

  // Editor de tema: tudo do carrinho fica na seção "Carrinho lateral" (mini_cart)
  function isCartSection(el) {
    var sec = el && el.closest ? el.closest('.shopify-section') : null;
    return !!(sec && (sec.id === 'shopify-section-mini_cart' || sec.querySelector('[data-hc-cart]')));
  }
  function openDrawerNow() {
    var jq = window.jQuery_T4NT;
    var d = document.getElementById('t4s-mini_cart');
    if (jq && d && window.T4SThemeSP && T4SThemeSP.Drawer && d.getAttribute('aria-hidden') !== 'false') {
      try { T4SThemeSP.Drawer.opend(jq(d)); } catch (err) {}
    }
  }
  // página do carrinho: a seção é desenhada no fim da página e vem para dentro da seção Carrinho
  function mountPage() {
    var m = document.querySelector('[data-hc-page-mount]');
    var s = document.getElementById('shopify-section-mini_cart');
    var c = s && s.querySelector('.hc-cart');
    if (m && c) { m.innerHTML = ''; m.appendChild(c); }
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (!isCartSection(e.target)) return;
    GOALS = null; OFFER = null; RECS = null;
    SS.del('hc_offer_off');
    mountPage();
    observe();
    $$('[data-hc-cart]').forEach(function (r) { r._offerKey = null; r._recsKey = null; r._ecrossLoaded = false; r._bestLoaded = false; });
    giftStyle();
    schedule();
    $$('[data-hc-cart]').forEach(function (r) { updateShipping(r); });
    editorOpen();
  });
  document.addEventListener('shopify:section:select', function (e) { if (isCartSection(e.target)) openDrawerNow(); });
  document.addEventListener('shopify:block:select', function (e) { if (isCartSection(e.target)) openDrawerNow(); });

  // Compra rápida do tema desligada (Configurações do tema): os botões que abririam a janela
  // de opções levam para a página do produto, em vez de abrir uma janela vazia.
  function quickShopOn() {
    return !!(window.T4Sconfigs && T4Sconfigs.enable_quickshop && window.T4Srequest && T4Srequest.quickshopId);
  }
  // Cada vitrine escolhe, nas opções do bloco, o que acontece ao tocar em "+ Adicionar" num produto
  // com variações: "page" (página do produto) ou "quickshop" (janela de escolha da variação do tema).
  function varAction(a) {
    var root = a.closest('[data-hc-cart]');
    if (!root) return 'quickshop';
    if (a.closest('[data-hc-best], [data-hc-ecross]')) return root.getAttribute('data-empty-var') || 'quickshop';
    if (a.closest('[data-hc-recs]')) return root.getAttribute('data-cross-var') || 'quickshop';
    return 'quickshop';
  }
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-hc-cart] [data-action-quickshop]');
    if (!a) return;
    var act = varAction(a);
    // Vitrines (Mais vendidos, Compre junto): janela de escolha da variação do próprio carrinho
    if (act === 'quickshop' && a.closest('[data-hc-best], [data-hc-ecross], [data-hc-recs]')) {
      e.preventDefault();
      e.stopPropagation();
      openVarModal(a);
      return;
    }
    if (quickShopOn() && act !== 'page') return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = href;
  }, true);

  // Enter no cupom e no CEP; máscara do CEP
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.closest || e.key !== 'Enter') return;
    if (t.matches('[data-hc-coupon-input]')) { e.preventDefault(); applyCoupon(t.closest('[data-hc-coupon]')); }
    else if (t.matches('[data-hc-cep-input]')) { e.preventDefault(); calcFromSheet(t.closest('[data-hc-cart]')); }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-hc-cep-input]')) {
      var f = formatCep(t.value);
      if (f !== t.value) t.value = f;
    } else if (t.matches('[data-hc-coupon-input]')) {
      couponError(t.closest('[data-hc-coupon]'), false);
    } else if (t.matches('[data-hc-note]')) {
      clearTimeout(S.noteTimer);
      var val = t.value;
      S.noteTimer = setTimeout(function () { postJSON(cartRoute('update.js'), { note: val }); }, 700);
    }
  });

  // Esc fecha a folha de frete antes da gaveta
  window.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var closed = false;
    $$('[data-hc-cart].has-sheet').forEach(function (r) { closed = closeVarModal(r) || closeGiftModal(r) || closeSheet(r) || closed; });
    if (closed) { e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  }, true);

  // Termos e item esgotado antes de ir para o checkout
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-hc-form]')) return;
    var agree = $('[data-hc-agree]', form);
    if (agree && !agree.checked) {
      e.preventDefault();
      show($('[data-hc-agree-err]', form), true);
      agree.focus();
      return;
    }
    if ($('.hc-item.is-soldout', form)) { e.preventDefault(); return; }
    if (S.busy) { e.preventDefault(); setTimeout(function () { form.requestSubmit ? form.requestSubmit($('[data-hc-checkout]', form)) : form.submit(); }, 400); }
  }, true);

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', function () { setTimeout(schedule, 50); });

  /* ------------------------------------- frete grátis por região e prêmios */

  var REGIONS = {
    'Sudeste': ['ES', 'MG', 'RJ', 'SP'], 'Sul': ['PR', 'RS', 'SC'], 'Centro-Oeste': ['DF', 'GO', 'MS', 'MT'],
    'Norte': ['AC', 'AM', 'AP', 'PA', 'RO', 'RR', 'TO'], 'Nordeste': ['AL', 'BA', 'CE', 'MA', 'PB', 'PE', 'PI', 'RN', 'SE']
  };
  var ICONS = {
    truck: 'M3 7h11v9H3zM14 10h4l3 3v3h-7M5.4 17.5a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0-3.2 0M15.4 17.5a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0-3.2 0',
    tag: 'M3 12V4h8l10 10-8 8L3 12zM6.1 8a1.4 1.4 0 1 0 2.8 0a1.4 1.4 0 1 0-2.8 0',
    percent: 'M19 5L5 19M4.5 6.5a2 2 0 1 0 4 0a2 2 0 1 0-4 0M15.5 17.5a2 2 0 1 0 4 0a2 2 0 1 0-4 0',
    gift: 'M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1.5S9.5 7 12 7zM12 7c1.5-3 5-3.5 5-1.5S14.5 7 12 7z',
    star: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z',
    heart: 'M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z',
    bolt: 'M13 3L5 13h6l-1 8 8-10h-6z',
    crown: 'M4 18h16M5 16l-1-9 5 4 3-6 3 6 5-4-1 9z',
    check: 'M5 12l5 5 9-10',
    pencil: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4'
  };
  function svg(name, size, stroke) {
    return '<svg class="hc-ic" width="' + (size || 18) + '" height="' + (size || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (stroke || 1.8) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (ICONS[name] || ICONS.star) + '"/></svg>';
  }

  var GOALS;
  function goals() {
    if (GOALS) return GOALS;
    var el = document.getElementById('hc-cart-goals');
    try { GOALS = el ? JSON.parse(el.textContent) : null; } catch (e) { GOALS = null; }
    return GOALS;
  }

  // Regra de frete grátis que vale para o CEP: estado › região › Brasil; empate = menor valor
  function freeShipping(G, cep) {
    var rules = (G.rules || []).filter(function (r) { return r.value > 0 && (r.area === 'brasil' || (r.list && r.list.length)); });
    if (!rules.length) return null;
    if (!cep) {
      var vals = rules.map(function (r) { return r.value; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
      if (vals.length === 1 && rules.some(function (r) { return r.area === 'brasil'; })) return { known: true, value: vals[0], label: '' };
      return { known: false, value: Math.min.apply(null, vals) };
    }
    var uf = cepToUF(cep);
    var region = '';
    Object.keys(REGIONS).forEach(function (k) { if (REGIONS[k].indexOf(uf) > -1) region = k; });
    var best = null;
    rules.forEach(function (r) {
      var rank = 0, label = '';
      if (r.area === 'estados' && r.list.indexOf(uf) > -1) { rank = 3; label = uf; }
      else if (r.area === 'regioes' && r.list.indexOf(region) > -1) { rank = 2; label = region; }
      else if (r.area === 'brasil') rank = 1;
      if (!rank) return;
      if (!best || rank > best.rank || (rank === best.rank && r.value < best.value)) best = { rank: rank, value: r.value, label: label };
    });
    if (!best) return { known: true, outside: true };
    var onlyOne = rules.length === 1;
    return { known: true, value: best.value, label: onlyOne ? '' : best.label };
  }

  function prizeLabel(p) { return p.kind === 'gift' ? (p.name || 'Brinde') : String(p.pct).replace('.', ',') + '% OFF'; }
  function prizePhrase(p) {
    if (p.kind !== 'gift') return prizeLabel(p);
    var n = (p.name || 'Brinde').trim();
    return (/a$/i.test(n) ? 'uma ' : 'um ') + n.toLowerCase();
  }
  function prizeIcon(p) {
    if (p.icon && p.icon !== 'auto') return p.icon;
    return p.kind === 'gift' ? 'gift' : 'tag';
  }
  function shortMoney(root, c) { return m(root, c).replace(/,00(?!\d)/, ''); }

  function renderGoals(root) {
    var foot = $('[data-hc-foot]', root);
    var box = foot && $('[data-hc-fsbar]', root);
    root._fs = { reached: false, simple: false };
    if (!box) return;
    var G = goals();
    if (!G || !G.bar) { box.innerHTML = ''; show(box, false); return; }
    root.style.setProperty('--hc-bar', G.color || '#1e6b47');
    root.style.setProperty('--hc-bar-bg', G.bg || '#f2f5f1');
    var total = parseInt(foot.getAttribute('data-total'), 10) || 0;
    var sub = parseInt(foot.getAttribute('data-subtotal'), 10) || total;
    var cep = getCep();
    var fs = freeShipping(G, cep);
    var tiers = [];
    if (fs && !fs.outside) {
      tiers.push({ id: 'frete', type: 'frete', value: fs.value, known: fs.known, base: total, label: 'Frete grátis', phrase: 'frete grátis', icon: 'truck', confetti: !!G.confetti, region: fs.label || '' });
    }
    (G.prizes || []).filter(function (p) { return p.value > 0; }).forEach(function (p) {
      tiers.push({ id: p.id, type: p.kind, value: p.value, known: true, base: sub, label: prizeLabel(p), phrase: prizePhrase(p), icon: prizeIcon(p), img: p.img, confetti: !!p.confetti, prize: p });
    });
    if (!tiers.length) { box.innerHTML = ''; show(box, false); return; }
    tiers.sort(function (a, b) { return a.value - b.value; });
    tiers.forEach(function (t) {
      t.done = t.known && t.base >= t.value;
      if (t.type === 'frete' && root._freeAvail === false) { t.done = false; t.noFree = true; }
    });
    // passou do valor, mas o Shopify não oferece frete grátis para este CEP: a barra não promete o que não existe
    tiers = tiers.filter(function (t) { return !(t.noFree && t.base >= t.value); });
    if (!tiers.length) { box.innerHTML = ''; show(box, false); return; }
    var reachedFS = tiers.some(function (t) { return t.type === 'frete' && t.done; });
    root._fs = { reached: reachedFS, simple: tiers.length === 1 && tiers[0].type === 'frete', tiers: tiers };
    show(box, true);
    box.classList.remove('is-done', 'is-prog');
    box.style.removeProperty('--hc-bar');

    if (root._fs.simple) {
      var t = tiers[0];
      if (!t.known) {
        box.innerHTML = '<button type="button" class="hc-fsbar__ask" data-hc-ship-open><span class="hc-fsbar__q">?</span><span>Calcule o frete e veja quanto falta para o <strong>frete grátis</strong></span></button>';
      } else if (t.done) {
        box.classList.add('is-done');
        box.innerHTML = '<span class="hc-fsbar__badge">' + svg('truck', 17, 1.9) + '</span>' +
          '<span class="hc-fsbar__txt"><strong class="hc-fsbar__title">Você ganhou frete grátis!</strong><span class="hc-fsbar__sub" data-hc-fs-sub>Informe o CEP para ver o prazo</span></span>' +
          '<span class="hc-fsbar__cep"><span class="hc-fsbar__cepnum" data-hc-cep-label hidden></span><button type="button" class="hc-link hc-link--strong hc-shipedit" data-hc-ship-open data-hc-cep-btn>Calcular</button></span>';
      } else {
        var pct = Math.min(100, Math.floor(t.base * 100 / t.value));
        box.innerHTML = '<div class="hc-fsbar__line"><span class="hc-fsbar__icon">' + svg('truck') + '</span><span>Faltam <strong>' + esc(m(root, t.value - t.base)) + '</strong> para ganhar <strong>frete grátis</strong>' + (t.region ? ' (' + esc(t.region) + ')' : '') + '</span></div>' +
          '<div class="hc-fsbar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progresso para o frete grátis"><span style="width:' + pct + '%"></span></div>';
      }
    } else {
      box.classList.add('is-prog');
      if (G.pcolor) box.style.setProperty('--hc-bar', G.pcolor);
      var maxV = tiers[tiers.length - 1].value || 1;
      var pos = progScale(tiers, maxV, G.firstMax);
      var next = tiers.filter(function (x) { return x.known && !x.done; })[0];
      var allDone = tiers.every(function (x) { return x.done; });
      var head;
      if (allDone) head = '<span class="hc-prog__hicon">' + svg('check', 18, 2) + '</span><span>Você desbloqueou <strong>todos os prêmios!</strong></span>';
      else if (next) head = '<span class="hc-prog__hicon">' + (next.img ? '<img src="' + esc(next.img) + '" alt="">' : svg(next.icon)) + '</span><span>Faltam <strong>' + esc(m(root, next.value - next.base)) + '</strong> para ganhar <strong>' + esc(next.phrase) + '</strong>' + (next.region ? ' (' + esc(next.region) + ')' : '') + '</span>';
      else head = '<span class="hc-prog__hicon">' + svg('star') + '</span><span>Calcule o frete para ver o que falta</span>';
      var fill = Math.min(100, Math.floor(pos(sub)));
      var marks = tiers.map(function (x, i) {
        var left = Math.max(0, Math.min(100, Math.round(pos(x.value))));
        var inner = !x.known ? '?' : (x.img ? '<img src="' + esc(x.img) + '" alt="">' : svg(x.icon, 15, 1.9));
        var align = left < 12 ? ' is-start' : (left > 88 ? ' is-end' : '');
        return '<div class="hc-prog__mark' + (x.done ? ' is-done' : '') + align + '" style="left:' + left + '%">' +
          '<button type="button" class="hc-prog__dot" data-hc-tier="' + i + '" aria-label="Detalhes: ' + esc(x.label) + '">' + inner + '</button>' +
          '<span class="hc-prog__label">' + esc(x.label) + (x.known ? '<br>' + esc(shortMoney(root, x.value)) : '') + '</span></div>';
      }).join('');
      var unknown = tiers.some(function (x) { return !x.known; });
      box.innerHTML = '<div class="hc-prog__head">' + head + '</div>' +
        '<div class="hc-prog__rail"><div class="hc-prog__track"><span style="width:' + fill + '%"></span></div>' + marks + '</div>' +
        (unknown ? '<button type="button" class="hc-prog__hint" data-hc-ship-open><strong>?</strong> Calcule o frete para ver sua meta de frete grátis</button>' : '') +
        '<div class="hc-prog__tip" data-hc-tip role="tooltip" hidden></div>';
    }
    goalsConfetti(root, tiers);
  }

  function tipHtml(root, t) {
    var status = t.done ? 'Desbloqueado' : (t.known ? 'Faltam ' + m(root, t.value - t.base) : 'Informe o CEP');
    var text = '';
    if (t.type === 'frete') text = t.known ? 'Nas compras a partir de ' + m(root, t.value) + (t.region ? ' para ' + t.region : '') + '.' : 'O valor depende da sua região. Informe o CEP.';
    else if (t.type === 'discount') text = 'Desconto de ' + t.label.replace(' OFF', '') + ' no carrinho nas compras a partir de ' + m(root, t.value) + '.';
    else {
      var gifts = (t.prize && t.prize.gifts) || [];
      text = (gifts.length > 1 ? 'Escolha 1 entre estas opções' : 'Ganhe este ' + (t.prize.name || 'brinde').toLowerCase()) + ' nas compras a partir de ' + m(root, t.value) + (gifts.length ? ':' : '.');
    }
    var list = '';
    if (t.type === 'gift' && t.prize && t.prize.gifts && t.prize.gifts.length) {
      list = '<div class="hc-prog__gifts">' + t.prize.gifts.map(function (g) {
        return '<div class="hc-prog__gift"><span class="hc-prog__gimg">' + (g.img ? '<img src="' + esc(g.img) + '" alt="">' : '') + '</span>' +
          '<span class="hc-prog__ginfo"><span class="hc-prog__gname">' + esc(g.title) + '</span><span class="hc-prog__gprice"><s>' + esc(m(root, g.price)) + '</s> · <strong>Grátis</strong>' + (g.variants > 1 ? ' · ' + g.variants + ' opções' : '') + '</span></span></div>';
      }).join('') + '</div>';
    }
    return '<div class="hc-prog__tiphead"><span class="hc-prog__tiptitle">' + esc(t.label) + '</span><span class="hc-prog__tipstatus' + (t.done ? ' is-done' : '') + '">' + esc(status) + '</span>' +
      '<button type="button" class="hc-prog__tipclose" data-hc-tip-close aria-label="Fechar detalhes">' + '<svg class="hc-ic" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
      '<span class="hc-prog__tiptext">' + esc(text) + '</span>' + list;
  }

  function openTip(root, idx, pinned) {
    var tip = $('[data-hc-tip]', root);
    var t = root._fs && root._fs.tiers && root._fs.tiers[idx];
    if (!tip || !t) return;
    if (pinned && root._tipIdx === idx && !tip.hasAttribute('hidden') && root._tipPinned) { closeTip(root); return; }
    tip.innerHTML = tipHtml(root, t);
    show(tip, true);
    root._tipIdx = idx;
    root._tipPinned = !!pinned;
  }
  function closeTip(root) {
    var tip = $('[data-hc-tip]', root);
    if (tip) show(tip, false);
    root._tipIdx = null;
    root._tipPinned = false;
  }

  // Posição na barra de prêmios: o 1º prêmio fica no máximo em firstMax% (padrão 40%);
  // do 1º ao último, proporcional ao valor. O preenchimento segue a mesma escala.
  function progScale(tiers, maxV, firstMax) {
    var cap = Math.min(50, Math.max(5, parseFloat(firstMax) || 40));
    var v1 = tiers[0].value || 0;
    var p1 = maxV > 0 ? Math.min(v1 * 100 / maxV, cap) : 0;
    return function (v) {
      if (maxV <= 0) return 0;
      if (v1 <= 0 || v1 >= maxV) return v * 100 / maxV;
      if (v <= v1) return v * p1 / v1;
      return p1 + (v - v1) * (100 - p1) / (maxV - v1);
    };
  }

  function goalsConfetti(root, tiers) {
    var prev = null;
    try { prev = JSON.parse(SS.get('hc_tiers_done') || 'null'); } catch (e) {}
    var now = {};
    var fire = false;
    tiers.forEach(function (t) {
      if (!t.known) return;
      now[t.id + ':' + t.value] = t.done;
      if (prev && t.done && prev[t.id + ':' + t.value] === false) {
        track(t.type === 'frete' ? 'hc_free_shipping_reached' : 'hc_prize_unlocked', { prize: t.label, threshold: t.value / 100 });
        if (t.confetti) fire = true;
      }
    });
    SS.set('hc_tiers_done', JSON.stringify(now));
    if (fire && visible(root)) {
      try { if (window.T4SThemeSP && typeof T4SThemeSP.CanvasConfetti === 'function') T4SThemeSP.CanvasConfetti(); } catch (e) {}
    }
  }

  /* ------------------------------------------------------------- brinde */

  function giftPrizes() {
    var G = goals();
    return G && G.prizes ? G.prizes.filter(function (p) { return p.kind === 'gift' && p.value > 0 && (p.gifts || []).length; }) : [];
  }
  function giftOptions(p) {
    return (p.gifts || []).map(function (g) {
      return { g: g, vars: (g.options || []).filter(function (v) { return v.available; }) };
    }).filter(function (o) { return o.vars.length; });
  }
  function giftName(p) { return ((p && p.name) || 'Brinde').trim() || 'Brinde'; }
  function giftDeclined(id, set) {
    var map = {};
    try { map = JSON.parse(SS.get('hc_gift_declined') || '{}'); } catch (e) {}
    if (set !== undefined) { if (set) map[id] = 1; else delete map[id]; SS.set('hc_gift_declined', JSON.stringify(map)); }
    return !!map[id];
  }
  S.giftTried = {};
  S.giftRemoved = null;

  function giftBanner(root, p) {
    var n = giftName(p).toLowerCase();
    return '<div class="hc-gift-pending"><span class="hc-gift-pending__icon">' + svg('gift', 18) + '</span>' +
      '<span class="hc-gift-pending__txt"><strong>' + esc(p.modalTitle || 'Você ganhou um presente!') + '</strong><span>Escolha seu ' + esc(n) + ' para ele entrar no pedido</span></span>' +
      '<button type="button" class="hc-gift-pending__btn ' + giftBtnCls() + '" data-hc-gift-open="' + esc(p.id) + '">Escolher</button></div>';
  }

  function syncGifts(root) {
    var foot = $('[data-hc-foot]', root);
    var slot = $('[data-hc-gift-slot]', root);
    if (!foot || !slot) return;
    var sub = parseInt(foot.getAttribute('data-subtotal'), 10) || 0;
    var prizes = giftPrizes();
    var lines = $$('[data-hc-gift-line]', root);
    var html = '';

    // brinde que não vale mais (valor abaixo ou prêmio removido do painel): sai do carrinho
    var drop = [];
    lines.forEach(function (l) {
      var p = prizes.filter(function (x) { return x.id === l.getAttribute('data-hc-gift-line'); })[0];
      if (!p || sub < p.value) { drop.push(l.getAttribute('data-key')); if (p) { S.giftRemoved = p; delete S.giftTried[p.id]; } }
    });
    if (drop.length) {
      if (!S.busy) removeGiftLines(root, drop);
      return;
    }

    prizes.forEach(function (p) {
      var line = lines.filter(function (l) { return l.getAttribute('data-hc-gift-line') === p.id; })[0];
      var opts = giftOptions(p);
      if (line) {
        var swap = $('[data-hc-gift-swap]', line);
        var many = opts.length > 1 || (opts[0] && opts[0].vars.length > 1);
        if (swap) show(swap, many);
        return;
      }
      if (sub < p.value) {
        delete S.giftTried[p.id];
        if (S.giftRemoved && S.giftRemoved.id === p.id) {
          html += '<div class="hc-gift-removed">Seu ' + esc(giftName(p).toLowerCase()) + ' saiu do carrinho porque o valor ficou abaixo de ' + esc(m(root, p.value)) + '. Volte a esse valor para ganhar de novo.</div>';
        }
        return;
      }
      if (S.giftRemoved && S.giftRemoved.id === p.id) S.giftRemoved = null;
      if (!opts.length) return;
      var single = opts.length === 1 && opts[0].vars.length === 1;
      if (giftDeclined(p.id)) { html += giftBanner(root, p); return; }
      if (single) {
        if (!S.giftTried[p.id] && !S.busy) { S.giftTried[p.id] = 1; addGift(root, p, opts[0].vars[0].id); }
        return;
      }
      html += giftBanner(root, p);
      if (!SS.get('hc_gift_modal_' + p.id) && visible(root)) {
        SS.set('hc_gift_modal_' + p.id, '1');
        setTimeout(function () { openGiftModal(root, p); }, 350);
      }
    });
    if (slot.innerHTML !== html) slot.innerHTML = html;
  }

  function addGift(root, p, variantId, then) {
    setBusy(root, true);
    var payload = { items: [{ id: Number(variantId), quantity: 1, properties: { _hc_gift: p.id, _hc_gift_name: giftName(p) } }] };
    if (!then) { payload.sections = sectionsParam(); payload.sections_url = window.location.pathname; }
    return postJSON(cartRoute('add.js'), payload).then(function (res) {
      setBusy(root, false);
      if (!res.ok) return;
      track('hc_gift_added', { prize: giftName(p), variant_id: Number(variantId), threshold: p.value / 100 });
      if (then) return then();
      applySections(res.json.sections);
    }).catch(function () { setBusy(root, false); });
  }

  function removeGiftLines(root, keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    setBusy(root, true);
    return postJSON(cartRoute('update.js'), { updates: updates, sections: sectionsParam(), sections_url: window.location.pathname })
      .then(function (res) { setBusy(root, false); applySections(res.json && res.json.sections); })
      .catch(function () { setBusy(root, false); });
  }

  function openGiftModal(root, p, currentVid) {
    var modal = $('[data-hc-gmodal]', root);
    var body = $('[data-hc-gmodal-body]', root);
    if (!modal || !body) return;
    var opts = giftOptions(p);
    var n = giftName(p).toLowerCase();
    root._gift = { prize: p, pick: null, vid: null };
    if (currentVid) {
      opts.forEach(function (o) { o.vars.forEach(function (v) { if (String(v.id) === String(currentVid)) { root._gift.pick = o.g.id; root._gift.vid = v.id; } }); });
    }
    if (opts.length === 1) { root._gift.pick = opts[0].g.id; if (opts[0].vars.length === 1) root._gift.vid = opts[0].vars[0].id; }
    body.innerHTML = '<div class="hc-gmodal__head"><span class="hc-gmodal__icon">' + svg('gift', 26, 1.7) + '</span>' +
      '<strong class="hc-gmodal__title">' + esc(p.modalTitle || 'Você ganhou um presente!') + '</strong>' +
      '<span class="hc-gmodal__sub">Seu pedido passou de ' + esc(m(root, p.value)) + '. Escolha 1 ' + esc(n) + ' para levar junto.</span></div>' +
      '<div class="hc-gmodal__list" data-hc-gmodal-list></div>' +
      '<button type="button" class="hc-gmodal__ok ' + giftBtnCls() + '" data-hc-gift-confirm disabled>Adicionar ' + esc(n) + ' ao carrinho</button>' +
      '<button type="button" class="hc-link hc-gmodal__later" data-hc-gmodal-close>Escolher depois</button>';
    renderGiftList(root);
    show(modal, true);
    root.classList.add('has-sheet');
  }

  function renderGiftList(root) {
    var st = root._gift; if (!st) return;
    var list = $('[data-hc-gmodal-list]', root);
    var opts = giftOptions(st.prize);
    list.innerHTML = opts.map(function (o) {
      var on = st.pick === o.g.id;
      var chips = on && o.vars.length > 1 ? '<div class="hc-gopt__vars">' + o.vars.map(function (v) {
        return '<button type="button" class="hc-gopt__var' + (String(st.vid) === String(v.id) ? ' is-on' : '') + '" data-hc-gift-var="' + v.id + '">' + esc(v.title) + '</button>';
      }).join('') + '</div>' : '';
      return '<div class="hc-gopt' + (on ? ' is-on' : '') + '"><button type="button" class="hc-gopt__main" data-hc-gift-pick="' + o.g.id + '">' +
        '<span class="hc-gopt__dot"></span><span class="hc-gopt__img">' + (o.g.img ? '<img src="' + esc(o.g.img) + '" alt="">' : '') + '</span>' +
        '<span class="hc-gopt__info"><span class="hc-gopt__name">' + esc(o.g.title) + '</span><span class="hc-gopt__price"><s>' + esc(m(root, o.g.price)) + '</s> <strong>Grátis</strong></span></span></button>' + chips + '</div>';
    }).join('');
    var ok = $('[data-hc-gift-confirm]', root);
    if (ok) ok.disabled = !st.vid;
  }

  function closeGiftModal(root) {
    var modal = $('[data-hc-gmodal]', root);
    if (!modal || modal.hasAttribute('hidden')) return false;
    show(modal, false);
    root.classList.remove('has-sheet');
    return true;
  }

  function confirmGift(root) {
    var st = root._gift; if (!st || !st.vid) return;
    var p = st.prize;
    var old = $$('[data-hc-gift-line="' + p.id + '"]', root).map(function (l) { return { key: l.getAttribute('data-key'), vid: l.getAttribute('data-vid') }; });
    closeGiftModal(root);
    giftDeclined(p.id, false);
    if (old.length && String(old[0].vid) === String(st.vid)) return;
    if (!old.length) { addGift(root, p, st.vid); return; }
    addGift(root, p, st.vid, function () {
      return removeGiftLines(root, old.map(function (o) { return o.key; }));
    });
  }

  /* ------------------------------- janela de escolha da variação (vitrines) */

  // Produto com variações numa vitrine (Mais vendidos, Compre junto): abre uma janela dentro do
  // carrinho para escolher a variação e adicionar, sem depender da compra rápida do tema.
  function varProduct(j) {
    var variants = (j.variants || []).map(function (v) {
      var img = v.featured_image && (v.featured_image.src || v.featured_image);
      return {
        id: v.id,
        available: v.available !== false,
        price: Number(v.price) || 0,
        compare: Number(v.compare_at_price) || 0,
        opts: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }),
        img: typeof img === 'string' ? img : ''
      };
    });
    var opts = (j.options || []).map(function (o) {
      return typeof o === 'string' ? { name: o, values: [] } : { name: o.name, values: (o.values || []).slice() };
    });
    opts.forEach(function (o, i) {
      if (o.values.length) return;
      variants.forEach(function (v) { if (v.opts[i] != null && o.values.indexOf(v.opts[i]) < 0) o.values.push(v.opts[i]); });
    });
    var img = j.featured_image || (j.images && j.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    return { id: j.id, title: j.title, options: opts, variants: variants, img: img };
  }
  function varImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }
  function varFind(st) {
    return st.p.variants.filter(function (v) {
      return v.opts.length === st.sel.length && v.opts.every(function (o, i) { return o === st.sel[i]; });
    })[0] || null;
  }
  function varOn(st, i, val) {
    return st.p.variants.some(function (v) {
      return v.available && v.opts[i] === val && st.sel.every(function (s, j) { return j === i || v.opts[j] === s; });
    });
  }

  function openVarModal(a) {
    var root = a.closest('[data-hc-cart]');
    var modal = root && $('[data-hc-vmodal]', root);
    var body = root && $('[data-hc-vmodal-body]', root);
    var href = a.getAttribute('href') || '';
    var hm = (a.pathname || href).match(/\/products\/([^\/?#]+)/);
    if (!modal || !body || !hm) { if (href) window.location.href = href; return; }
    var list = a.closest('[data-hc-recs]') ? 'compre_junto' : (a.closest('[data-hc-ecross]') ? 'compre_junto_vazio' : 'mais_vendidos');
    var token = {};
    root._varReq = token;
    root._var = null;
    body.innerHTML = '<div class="hc-vload">Carregando opções…</div>';
    show(modal, true);
    root.classList.add('has-sheet');
    var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    fetch(base + '/products/' + hm[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function (j) {
        if (root._varReq !== token) return;
        var p = varProduct(j);
        if (!p.variants.length) throw new Error('x');
        if (p.variants.length === 1) {
          closeVarModal(root);
          var only = p.variants[0];
          if (only.available) addVariant(root, only.id, null);
          else window.location.href = href;
          return;
        }
        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        root._var = { p: p, sel: first.opts.slice(), list: list, href: href };
        renderVarModal(root);
      })
      .catch(function () {
        if (root._varReq !== token) return;
        closeVarModal(root);
        window.location.href = href;
      });
  }

  function renderVarModal(root) {
    var st = root._var; if (!st) return;
    var body = $('[data-hc-vmodal-body]', root); if (!body) return;
    var p = st.p;
    var v = varFind(st);
    var shownImg = (v && v.img) || p.img;
    var price = v ? v.price : (p.variants[0] ? p.variants[0].price : 0);
    var cmp = v && v.compare > v.price ? '<s>' + esc(m(root, v.compare)) + '</s> ' : '';
    var groups = p.options.map(function (o, i) {
      var chips = o.values.map(function (val) {
        var cls = 'hc-gopt__var' + (st.sel[i] === val ? ' is-on' : '') + (varOn(st, i, val) ? '' : ' is-off');
        return '<button type="button" class="' + cls + '" data-hc-var-opt="' + i + '" data-hc-var-val="' + esc(val) + '" aria-pressed="' + (st.sel[i] === val) + '">' + esc(val) + '</button>';
      }).join('');
      return '<div class="hc-vgroup"><span class="hc-vgroup__label">' + esc(o.name) + (st.sel[i] != null ? ': <strong>' + esc(st.sel[i]) + '</strong>' : '') + '</span>' +
        '<div class="hc-gopt__vars hc-vgroup__vals">' + chips + '</div></div>';
    }).join('');
    var ok = !!(v && v.available);
    var label = !v ? 'Combinação indisponível' : (v.available ? 'Adicionar ao carrinho' : 'Esgotado');
    body.innerHTML =
      '<div class="hc-vhead">' +
        '<span class="hc-vhead__img">' + (shownImg ? '<img src="' + esc(varImg(shownImg, 160)) + '" alt="">' : '') + '</span>' +
        '<span class="hc-vhead__info"><strong class="hc-vhead__name">' + esc(p.title) + '</strong><span class="hc-vhead__price">' + cmp + esc(m(root, price)) + '</span></span>' +
        '<button type="button" class="hc-sheet__close" data-hc-vmodal-close aria-label="Fechar"><svg class="hc-ic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '</div>' + groups +
      '<button type="button" class="hc-gmodal__ok ' + btnCls() + '" data-hc-var-add' + (ok ? '' : ' disabled') + '>' + esc(label) + '</button>';
  }

  function closeVarModal(root) {
    var modal = $('[data-hc-vmodal]', root);
    if (!modal || modal.hasAttribute('hidden')) return false;
    root._varReq = null;
    root._var = null;
    show(modal, false);
    root.classList.remove('has-sheet');
    return true;
  }

  function confirmVar(root, btn) {
    var st = root._var; if (!st || S.busy) return;
    var v = varFind(st);
    if (!v || !v.available) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando…';
    setBusy(root, true);
    postJSON(cartRoute('add.js'), { items: [{ id: Number(v.id), quantity: 1 }], sections: sectionsParam(), sections_url: window.location.pathname })
      .then(function (res) {
        setBusy(root, false);
        if (!res.ok) {
          btn.textContent = 'Indisponível';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
          return;
        }
        track('hc_cross_sell_add', { variant_id: Number(v.id), list: st.list, via: 'janela_variacao' });
        closeVarModal(root);
        applySections(res.json.sections);
      })
      .catch(function () {
        setBusy(root, false);
        btn.disabled = false;
        btn.textContent = label;
      });
  }

  /* ----------------------------------------------- eventos (Meta / GA4) */

  // Publica eventos próprios do carrinho no sistema de eventos do Shopify ("Eventos do cliente").
  // Não chama o Pixel da Meta nem o GA4 direto, para não duplicar o que os apps oficiais já enviam.
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {});
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('hc:' + name, { detail: data || {} })); } catch (e) {}
  }

  /* --------------------------------------------- produto temporário (PDP) */

  function cleanupTemp() {
    if (!SS.get('hc_temp_pending') && !LS.get('hc_temp_pending')) return;
    fetch(cartRoute('').replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var temps = (cart.items || []).filter(function (it) { return it.properties && it.properties._hc_temp; });
        if (!temps.length) { SS.del('hc_temp_pending'); LS.del('hc_temp_pending'); return; }
        var updates = {};
        temps.forEach(function (it) { updates[it.key] = 0; });
        return postJSON(cartRoute('update.js'), { updates: updates }).then(function () {
          SS.del('hc_temp_pending'); LS.del('hc_temp_pending');
          refreshFromServer();
        });
      }).catch(function () {});
  }

  /* --------------------------------------------------------------- início */

  var MO = null;
  function observe() {
    var drawer = document.getElementById('t4s-mini_cart');
    var mount = document.querySelector('[data-hc-page-mount]');
    var targets = drawer ? [drawer] : [];
    if (mount) targets.push(mount);
    $$('[data-hc-cart]').forEach(function (r) { if ((!drawer || !drawer.contains(r)) && (!mount || !mount.contains(r))) targets.push(r); });
    if (!window.MutationObserver) return;
    if (MO) MO.disconnect();
    var mo = MO = new MutationObserver(schedule);
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    if (drawer && !drawer._hcWatch) {
      drawer._hcWatch = true;
      // ao abrir a gaveta: se o CEP mudou em outra página (ex.: produto), recalcula
      new MutationObserver(function () {
        if (drawer.getAttribute('aria-hidden') !== 'false') return;
        var root = $('[data-hc-cart]', drawer);
        if (root && root._shipCep !== getCep()) updateShipping(root);
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  function editorOpen() {
    var tries = 0;
    (function tick() {
      var root = document.querySelector('#t4s-mini_cart [data-hc-cart]');
      var jq = window.jQuery_T4NT;
      if (root && root.dataset.editorOpen === 'true' && jq && window.T4SThemeSP && T4SThemeSP.Drawer) {
        try { T4SThemeSP.Drawer.opend(jq('#t4s-mini_cart')); } catch (e) {}
        return;
      }
      if (++tries < 40) setTimeout(tick, 250);
    })();
  }

  /* ------------------------------------------- pontinhos das listas que deslizam */
  var dotsRO = window.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (e) { syncDots(e.target); }); }) : null;
  var dotsSeen = window.WeakSet ? new WeakSet() : null;
  function syncDots(list) {
    if (!list || !list.parentNode) return;
    if (dotsRO && dotsSeen && !dotsSeen.has(list)) { dotsSeen.add(list); dotsRO.observe(list); }
    var dots = list.nextElementSibling;
    if (!dots || !dots.classList.contains('hc-dots')) {
      dots = document.createElement('div');
      dots.className = 'hc-dots';
      dots.setAttribute('hidden', '');
      list.parentNode.insertBefore(dots, list.nextSibling);
    }
    var w = list.clientWidth;
    var scrolls = window.getComputedStyle(list).overflowX !== 'visible';
    var pw = dotsPage(list);
    var room = list.scrollWidth - w;
    var n = w > 0 && scrolls && room > 4 ? Math.ceil((room - 4) / pw) + 1 : 0;
    if (n <= 1 || list.hasAttribute('hidden')) { dots.setAttribute('hidden', ''); return; }
    var cur = list.scrollLeft >= room - 4 ? n - 1 : Math.min(n - 1, Math.round(list.scrollLeft / pw));
    if (dots.childElementCount !== n) {
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hc-dot';
        b.setAttribute('data-hc-dot', String(i));
        b.setAttribute('aria-label', 'Mostrar parte ' + (i + 1) + ' de ' + n);
        dots.appendChild(b);
      }
    }
    Array.prototype.forEach.call(dots.children, function (b, i) {
      b.classList.toggle('is-on', i === cur);
      if (i === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    dots.removeAttribute('hidden');
  }
  // quanto a lista anda por ponto: só produtos inteiros
  function dotsPage(list) {
    var cs = window.getComputedStyle(list);
    var first = list.firstElementChild;
    var gap = parseFloat(cs.columnGap) || 0;
    var item = first ? first.getBoundingClientRect().width + gap : 0;
    var inner = list.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    if (!item || item <= 0) return Math.max(1, list.clientWidth);
    return Math.max(1, Math.floor((inner + gap) / item)) * item;
  }
  var dotsQueued = false;
  function syncAllDots() {
    if (dotsQueued) return;
    dotsQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      dotsQueued = false;
      Array.prototype.forEach.call(document.querySelectorAll('.hc-cart .hc-hscroll'), syncDots);
    });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('hc-hscroll')) syncDots(t);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-hc-dot]');
    if (!b) return;
    var list = b.parentNode && b.parentNode.previousElementSibling;
    if (!list) return;
    e.preventDefault();
    var idx = parseInt(b.getAttribute('data-hc-dot'), 10);
    var last = idx === b.parentNode.childElementCount - 1;
    list.scrollTo({ left: last ? list.scrollWidth : idx * dotsPage(list), behavior: 'smooth' });
  });
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var t = ms[i].target;
        if (t.nodeType === 1 && (t.closest('.hc-cart') || t.querySelector('.hc-cart'))) { syncAllDots(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.addEventListener('resize', syncAllDots);

  function init() {
    syncAllDots();
    mountPage();
    observe();
    schedule();
    cleanupTemp();
    if (window.Shopify && window.Shopify.designMode) editorOpen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.HCCart = {
    cepToUF: cepToUF,
    formatMoney: formatMoney,
    deliveryText: function (rate, opts) { return deliveryText(rate, { format: (opts && opts.format) || 'date', prefix: (opts && opts.prefix) || 'Chega até' }, rateCents(rate) === 0); },
    refresh: refreshFromServer,
    _process: schedule
  };
})();
